import { useState, useEffect, useCallback, useRef } from "react";
import { useSearchParams, useParams } from "react-router-dom";
import axios from "axios";
import { useAuth, API } from "../App";
import TicketsStatsTab from "./TicketsStatsTab";
import TicketsReasignadosTab from "./TicketsReasignadosTab";
import HallazgosConfigTitulosTab from "./HallazgosConfigTitulosTab";
import { toast } from "sonner";
import Sidebar from "../components/Sidebar";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "../components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { SearchableSelect } from "../components/ui/searchable-select";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../components/ui/dialog";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { ScrollArea } from "../components/ui/scroll-area";
import { Checkbox } from "../components/ui/checkbox";
import {
  Ticket,
  Loader2,
  Search,
  Plus,
  Eye,
  Trash2,
  Clock,
  CheckCircle2,
  AlertTriangle,
  MessageSquare,
  User,
  Users,
  Phone,
  Mail,
  Send,
  Upload,
  FileText,
  X,
  ArrowUp,
  Download,
  Building2,
  Calendar,
  PackageCheck,
  FormInput,
  LayoutGrid,
  List,
  Table2,
  Columns3,
  Pencil
} from "lucide-react";
import { ArrowRightLeft, History, FileDown, AlertCircle, UserCheck, Filter, Paperclip, ShieldCheck, RotateCcw } from "lucide-react";
import { ClienteAtencionWatcher } from "../contexts/AtencionPrioritariaContext";
import ViewSelector from "../components/ViewSelector";
import KanbanView from "../components/KanbanView";
import CardsView from "../components/CardsView";
import ListView from "../components/ListView";
import useViewPreference from "../hooks/useViewPreference";

export default function TicketsPage({ modulo = null, embedded = false, abrirTicket = null }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tickets, setTickets] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [prioridades, setPrioridades] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [usuariosCategoria, setUsuariosCategoria] = useState([]);
  const [usuariosDepartamento, setUsuariosDepartamento] = useState([]);
  const [subCategoriasDisponibles, setSubCategoriasDisponibles] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScrollTop(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  const [showDialog, setShowDialog] = useState(false);
  const [showDetailDialog, setShowDetailDialog] = useState(false);
  const [showEditDialog, setShowEditDialog] = useState(false);
  const [editingTicket, setEditingTicket] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  // Initialize estadoFilter from URL query param or default to "all"
  const [estadoFilter, setEstadoFilter] = useState(() => {
    const urlEstado = searchParams.get("estado");
    return urlEstado || "all";
  });
  const [prioridadFilter, setPrioridadFilter] = useState("all");
  const [categoriaFilter, setCategoriaFilter] = useState("all");
  const [subCategoriaFilter, setSubCategoriaFilter] = useState("all");
  const [departamentoCreadorFilter, setDepartamentoCreadorFilter] = useState("all");
  const [tipoFilter, setTipoFilter] = useState("all");
  const [viaFilter, setViaFilter] = useState("all");
  const [showTypeDialog, setShowTypeDialog] = useState(false);
  const [reglasSubcat, setReglasSubcat] = useState([]);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");
  // Grouped filter selector (replicates ControlRenovaciones UX)
  const [activeFilterColumn, setActiveFilterColumn] = useState("");
  const [activeFilterValue, setActiveFilterValue] = useState("");
  // Filtro "Asignados a mí" + filtro de asignado específico
  const [asignadoAMiFilter, setAsignadoAMiFilter] = useState(false);
  const [slaFilter, setSlaFilter] = useState("all");
  const [asignadoUserFilter, setAsignadoUserFilter] = useState("all");
  // Lista de usuarios visibles para el filtro "Asignado a" según jerarquía
  const [allowedAssignees, setAllowedAssignees] = useState([]);
  const [canSeeAsignadoFilter, setCanSeeAsignadoFilter] = useState(false);
  const [exportingExcel, setExportingExcel] = useState(false);
  const [nuevoComentario, setNuevoComentario] = useState("");
  const [sendingComment, setSendingComment] = useState(false);
  const [attachingSupport, setAttachingSupport] = useState(false);
  const supportFileRef = useRef(null);
  const [activeTab, setActiveTab] = useState("tickets");
  const [uploadingFile, setUploadingFile] = useState(false);
  const [isSubmittingTicket, setIsSubmittingTicket] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [loadingPlantilla, setLoadingPlantilla] = useState(false);
  // Custom template fields state
  const [templateFields, setTemplateFields] = useState([]);
  const [customFieldsData, setCustomFieldsData] = useState({});
  const [plantillasCategoria, setPlantillasCategoria] = useState([]);
  // View state - persisted in localStorage
  const [viewMode, setViewMode] = useViewPreference("tickets", "table");
  // Reassignment state
  const [showReassignDialog, setShowReassignDialog] = useState(false);
  const [reassignLoading, setReassignLoading] = useState(false);
  const [reassignMotivo, setReassignMotivo] = useState("");
  const [reassignUsuarioId, setReassignUsuarioId] = useState("");
  const [reassignDeptFilter, setReassignDeptFilter] = useState("");
  const [reassignUsuarios, setReassignUsuarios] = useState([]);
  const [correspondenciaLoading, setCorrespondenciaLoading] = useState(false);
  const [showDeclinarDialog, setShowDeclinarDialog] = useState(false);
  const [declinarMotivo, setDeclinarMotivo] = useState("");
  const fileInputRef = useRef(null);
  const { getAuthHeaders, user } = useAuth();
  // Cabeceras con módulo (Hallazgos Auditoria) cuando aplica
  const authH = () => {
    const base = (getAuthHeaders)();
    return modulo ? { ...base, headers: { ...base.headers, "X-Modulo": modulo } } : base;
  };
  // ===== Hallazgos Auditoria: cierre definitivo, plan de acción =====
  const [cerradoresInfo, setCerradoresInfo] = useState({ user_ids: [], puede_cerrar: false });
  const [estatusFinalSel, setEstatusFinalSel] = useState("");
  const [notaNoCumple, setNotaNoCumple] = useState("");
  const [savingEstatusFinal, setSavingEstatusFinal] = useState(false);
  const [planAccion, setPlanAccion] = useState("");
  const [fechaCompromiso, setFechaCompromiso] = useState("");
  const [savingPlan, setSavingPlan] = useState(false);
  const compromisoVencido = (t) =>
    modulo && t?.fecha_compromiso && String(t.fecha_compromiso).slice(0, 10) < new Date().toISOString().slice(0, 10)
    && !["resuelto", "cerrado", "completado"].includes(t.estado);

  // Semáforo SLA: verde = en tiempo, ámbar = por vencer (≤25% del SLA), rojo = vencido/incumplido
  const fmtTiempoSla = (ms) => {
    const h = Math.abs(ms) / 3600000;
    if (h >= 48) return `${(h / 24).toFixed(1)} días`;
    if (h >= 1) return `${h.toFixed(1)} h`;
    return `${Math.round(h * 60)} min`;
  };
  const slaSemaforo = (t) => {
    const prioNorm = (t.prioridad || "").toLowerCase();
    const p = prioridades.find((x) => x.id && x.id === t.prioridad_id) ||
      prioridades.find((x) => (x.name || "").toLowerCase() === prioNorm);
    const slaH = p?.sla_hours;
    if (!slaH || !t.fecha_creacion) return null;
    const fc = new Date(t.fecha_creacion);
    if (isNaN(fc.getTime())) return null;
    const limite = fc.getTime() + slaH * 3600000;
    const cerrado = ["resuelto", "cerrado", "completado"].includes((t.estado || "").toLowerCase());
    if (cerrado) {
      if (!t.fecha_resolucion) return null;
      const fr = new Date(t.fecha_resolucion);
      if (isNaN(fr.getTime())) return null;
      return fr.getTime() <= limite
        ? { key: "verde", clase: "bg-green-500", label: "SLA cumplido (resuelto a tiempo)" }
        : { key: "rojo", clase: "bg-red-500", label: `SLA incumplido (excedió por ${fmtTiempoSla(fr.getTime() - limite)})` };
    }
    const restante = limite - Date.now();
    if (restante <= 0) return { key: "rojo", clase: "bg-red-500", pulse: true, label: `SLA vencido hace ${fmtTiempoSla(restante)}` };
    if (restante <= slaH * 3600000 * 0.25) return { key: "ambar", clase: "bg-amber-500", pulse: true, label: `SLA por vencer — quedan ${fmtTiempoSla(restante)}` };
    return { key: "verde", clase: "bg-green-500", label: `En tiempo — quedan ${fmtTiempoSla(restante)} de SLA` };
  };
  const { ticketId: urlTicketId } = useParams();
  const [estatusFinalFilter, setEstatusFinalFilter] = useState("all");

  // Abrir detalle desde el calendario de compromisos (Hallazgos)
  useEffect(() => {
    if (abrirTicket?.id) {
      (async () => {
        try {
          const res = await axios.get(`${API}/tickets/${abrirTicket.id}`, authH());
          setSelectedTicket(res.data);
          setShowDetailDialog(true);
        } catch {
          toast.error("Hallazgo no encontrado");
        }
      })();
    }
  }, [abrirTicket]);// eslint-disable-line react-hooks/exhaustive-deps

  // Auto-open ticket from URL parameter
  useEffect(() => {
    if (urlTicketId && !loading) {
      (async () => {
        try {
          const res = await axios.get(`${API}/tickets/${urlTicketId}`, authH());
          setSelectedTicket(res.data);
          setShowDetailDialog(true);
        } catch (err) {
          toast.error("Ticket no encontrado");
        }
      })();
    }
  }, [urlTicketId, loading]);// eslint-disable-line react-hooks/exhaustive-deps

  // Correspondencia Interna handlers
  const isCorrespondenciaTicket = (ticket) => ticket?.tipo === "correspondencia_interna";

  const handleRecibirCorrespondencia = async () => {
    if (!selectedTicket) return;
    setCorrespondenciaLoading(true);
    try {
      await axios.post(`${API}/correspondencia-interna/recibir/${selectedTicket.id}`, {}, authH());
      toast.success("Correspondencia recibida exitosamente");
      const res = await axios.get(`${API}/tickets/${selectedTicket.id}`, authH());
      setSelectedTicket(res.data);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al recibir correspondencia");
    } finally { setCorrespondenciaLoading(false); }
  };

  const handleDeclinarCorrespondencia = async () => {
    if (!selectedTicket || !declinarMotivo.trim()) {
      toast.error("Ingrese un motivo para declinar");
      return;
    }
    setCorrespondenciaLoading(true);
    try {
      await axios.post(`${API}/correspondencia-interna/declinar/${selectedTicket.id}`, { motivo: declinarMotivo }, authH());
      toast.success("Correspondencia declinada");
      setShowDeclinarDialog(false);
      setDeclinarMotivo("");
      const res = await axios.get(`${API}/tickets/${selectedTicket.id}`, authH());
      setSelectedTicket(res.data);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al declinar correspondencia");
    } finally { setCorrespondenciaLoading(false); }
  };

  // Check if user can change ticket status — ONLY admin or the assigned user
  const canChangeStatus = (ticket) => {
    if (!ticket || !user) return false;
    const role = user?.role?.toLowerCase() || "";
    const isAdmin = ["administrador", "admin", "superadmin"].includes(role);
    const isAssigned = ticket.asignado_a === user.id;
    return isAdmin || isAssigned;
  };

  const userIsAdmin = () => ["administrador", "admin", "superadmin"].includes((user?.role || "").toLowerCase());

  // Supervisores y admins pueden escalar un ticket a URGENTE
  const canEscalateUrgente = () => {
    const role = (user?.role || "").toLowerCase();
    return ["administrador", "admin", "superadmin", "supervisor"].includes(role) || !!user?.is_supervisor;
  };

  // Check if user can edit a specific ticket - admin, creator, or supervisor
  // (la lista de tickets ya está acotada a la jerarquía del supervisor en backend,
  // y el PUT valida el alcance, por lo que mostrar Editar a supervisores es seguro).
  const canEditTicket = (ticket) => {
    if (!ticket || !user) return false;
    const role = user?.role?.toLowerCase() || "";
    const isAdmin = ["administrador", "admin", "superadmin"].includes(role);
    const isCreator = ticket.user_id === user.id || ticket.created_by === user.id;
    const isSupervisor = role === "supervisor" || !!user?.is_supervisor;
    return isAdmin || isCreator || isSupervisor;
  };

  // Check if user can delete a specific ticket - ONLY admin can delete
  const canDeleteTicket = () => {
    if (!user) return false;
    const role = user?.role?.toLowerCase() || "";
    return ["administrador", "admin", "superadmin"].includes(role);
  };

  // Solo admin y supervisor pueden exportar a Excel
  const canExportTickets = () => {
    if (!user) return false;
    const role = user?.role?.toLowerCase() || "";
    if (["administrador", "admin", "superadmin", "supervisor"].includes(role)) return true;
    // Aceptamos tambien al usuario que tenga supervisados (is_supervisor flag computado en backend)
    return !!user?.is_supervisor;
  };

  // Open edit dialog
  const openEditDialog = (ticket) => {
    setEditingTicket(ticket);
    setFormData({
      titulo: ticket.titulo,
      descripcion: ticket.descripcion,
      prioridad_id: ticket.prioridad_id || "",
      categoria_id: ticket.categoria_id || "",
      sub_categoria: ticket.sub_categoria || "",
      departamento_id: ticket.departamento_id || "",
      asignado_a: ticket.asignado_a || "",
      solicitante_nombre: ticket.solicitante_nombre || "",
      solicitante_email: ticket.solicitante_email || "",
      solicitante_telefono: ticket.solicitante_telefono || "",
      solicitante_extension: ticket.solicitante_extension || "",
      archivos_adjuntos: ticket.archivos_adjuntos || [],
      es_urgente: !!ticket.es_urgente
    });
    setAttachedFiles(ticket.archivos_adjuntos || []);
    setShowEditDialog(true);
  };

  // Update ticket
  const updateTicket = async () => {
    if (!editingTicket) return;
    try {
      await axios.put(`${API}/tickets/${editingTicket.id}`, {
        ...formData,
        archivos_adjuntos: attachedFiles
      }, authH());
      // Escalación URGENTE: si cambió el flag y el usuario puede escalar,
      // se aplica vía endpoint dedicado (ajusta prioridad y notifica).
      if (canEscalateUrgente() && !!formData.es_urgente !== !!editingTicket.es_urgente) {
        await axios.post(`${API}/tickets/${editingTicket.id}/urgente`,
          { es_urgente: !!formData.es_urgente }, authH());
        if (formData.es_urgente) {
          toast.success("Ticket marcado como URGENTE. Se notificó al ejecutivo asignado y su supervisor.");
        } else {
          toast.success("Se quitó la marca URGENTE del ticket.");
        }
      } else {
        toast.success("Ticket actualizado correctamente");
      }
      setShowEditDialog(false);
      setEditingTicket(null);
      resetForm();
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al actualizar ticket");
    }
  };

  const [formData, setFormData] = useState({
    titulo: "",
    descripcion: "",
    tipo_ticket: "Solicitud",
    via: null,
    categoria_id: "",
    sub_categoria: "",
    prioridad: "media",
    prioridad_id: "",
    departamento_id: "",
    solicitante_nombre: "",
    solicitante_email: "",
    solicitante_telefono: "",
    asignado_a: "",
    archivos_adjuntos: [] // Array of {url, filename}
  });

  // Helper: determina si la "Departamento a asignar" seleccionada requiere
  // subcategoría. Ahora es configurable vía reglas (pestaña "Sub categorías");
  // se mantiene la lista fija de "Riesgos Generales" como respaldo.
  const SUBCAT_TRIGGER_PATTERNS = [
    "solicitud departamento riesgos generales",
    "solicitud dpto riesgos generales",
    "solicitud dept riesgos generales",
  ];
  const SUB_CATEGORIAS_RIESGOS = ["Emisión", "Minuta Reunión", "Revisión Checklist", "Otros"];
  const isRiesgosGenerales = (categoriaId) => {
    if (!categoriaId) return false;
    const cat = categorias.find((c) => c.id === categoriaId);
    if (!cat) return false;
    const name = (cat.name || "").trim().toLowerCase();
    return SUBCAT_TRIGGER_PATTERNS.some((p) => name === p || name.includes(p));
  };
  // Opciones de subcategoría: reglas configuradas; si no hay y es Riesgos
  // Generales, usa la lista fija de respaldo.
  const getSubCategoriaOptions = (categoriaId) => {
    if (subCategoriasDisponibles.length > 0) return subCategoriasDisponibles;
    if (isRiesgosGenerales(categoriaId)) return SUB_CATEGORIAS_RIESGOS;
    return [];
  };
  const needsSubCategoria = (categoriaId) => getSubCategoriaOptions(categoriaId).length > 0;

  useEffect(() => {
    if (!modulo) return;
    axios.get(`${API}/hallazgos-auditoria/cerradores`, authH())
      .then((r) => setCerradoresInfo(r.data))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modulo]);

  useEffect(() => {
    if (selectedTicket && modulo) {
      setPlanAccion(selectedTicket.plan_accion || "");
      setFechaCompromiso(String(selectedTicket.fecha_compromiso || "").slice(0, 10));
      setEstatusFinalSel("");
      setNotaNoCumple("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTicket?.id, modulo]);

  const refreshSelectedTicket = async (ticketId) => {
    try {
      const res = await axios.get(`${API}/tickets/${ticketId}`, authH());
      setSelectedTicket(res.data);
    } catch { /* noop */ }
    fetchData();
  };

  const guardarEstatusFinal = async () => {
    if (!estatusFinalSel) { toast.error("Seleccione el Estatus Final"); return; }
    if (estatusFinalSel === "no_cumple" && !notaNoCumple.trim()) { toast.error("Debe indicar la razón del No Cumple"); return; }
    try {
      setSavingEstatusFinal(true);
      const res = await axios.post(`${API}/tickets/${selectedTicket.id}/estatus-final`, { estatus: estatusFinalSel, nota: notaNoCumple }, authH());
      toast.success(res.data.message);
      await refreshSelectedTicket(selectedTicket.id);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al guardar el Estatus Final");
    } finally {
      setSavingEstatusFinal(false);
    }
  };

  const guardarPlanAccion = async () => {
    if (!planAccion.trim()) { toast.error("Escriba el plan de acción"); return; }
    try {
      setSavingPlan(true);
      await axios.put(`${API}/tickets/${selectedTicket.id}/plan-accion`, { plan_accion: planAccion, fecha_compromiso: fechaCompromiso || null }, authH());
      toast.success("Plan de acción guardado");
      await refreshSelectedTicket(selectedTicket.id);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Error al guardar el plan de acción");
    } finally {
      setSavingPlan(false);
    }
  };

  const fetchData = useCallback(async () => {
    try {
      const [ticketsRes, catsRes, statsRes, prioRes, deptRes, reglasRes] = await Promise.all([
        axios.get(`${API}/tickets`, authH()),
        axios.get(`${API}/tickets/categorias`, authH()),
        axios.get(`${API}/tickets/stats/summary`, authH()),
        axios.get(`${API}/tickets/prioridades`, authH()),
        axios.get(`${API}/departamentos`, authH()),
        axios.get(`${API}/tickets/subcategorias-reglas`, authH()).catch(() => ({ data: [] }))
      ]);
      setTickets(ticketsRes.data);
      setCategorias(catsRes.data);
      setStats(statsRes.data);
      setPrioridades(prioRes.data);
      setDepartamentos(deptRes.data);
      setReglasSubcat(reglasRes.data || []);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  }, [getAuthHeaders]);

  // Function to download all attachments as ZIP
  const downloadAllAttachments = async (ticketId, ticketNumero) => {
    try {
      toast.info("Preparando descarga...");
      const headers = authH();
      console.log("Download headers:", headers);
      
      const response = await axios.get(
        `${API}/tickets/${ticketId}/download-all-attachments`,
        {
          headers: headers.headers,
          responseType: 'blob'
        }
      );
      
      // Create blob URL and trigger download
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `ticket_${ticketNumero || ticketId.substring(0, 8)}_adjuntos.zip`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      toast.success("Descarga completada");
    } catch (err) {
      console.error("Error downloading attachments:", err);
      let errorMsg = "Error al descargar los archivos";
      const data = err.response?.data;
      const status = err.response?.status;
      // Con responseType:'blob', el cuerpo de error también llega como Blob:
      // hay que leerlo para mostrar el motivo real del backend.
      if (data instanceof Blob) {
        try {
          const text = await data.text();
          try {
            const parsed = JSON.parse(text);
            errorMsg = parsed.detail || errorMsg;
          } catch {
            if (text) errorMsg = text;
          }
        } catch {
          /* ignore */
        }
        if (status === 401 || status === 403) {
          errorMsg = "Error de autenticación - por favor recarga la página";
        }
      } else {
        errorMsg = data?.detail || errorMsg;
      }
      toast.error(errorMsg);
    }
  };

  // === Reassignment functions ===
  const openReassignDialog = async () => {
    setReassignMotivo("");
    setReassignUsuarioId("");
    setReassignDeptFilter("");
    try {
      const res = await axios.get(`${API}/tickets/usuarios-disponibles`, authH());
      setReassignUsuarios(res.data);
    } catch (err) {
      toast.error("Error al cargar usuarios");
    }
    setShowReassignDialog(true);
  };

  const filteredReassignUsuarios = reassignDeptFilter
    ? reassignUsuarios.filter(u => {
        const deptId = u.departamento_id || u.department_id || "";
        return deptId === reassignDeptFilter;
      })
    : reassignUsuarios;

  const handleReassign = async () => {
    if (!reassignUsuarioId) {
      toast.error("Debe seleccionar un usuario");
      return;
    }
    if (!reassignMotivo.trim()) {
      toast.error("El motivo es obligatorio");
      return;
    }
    setReassignLoading(true);
    try {
      const res = await axios.put(`${API}/tickets/${selectedTicket.id}/reasignar`, {
        nuevo_asignado_id: reassignUsuarioId,
        motivo: reassignMotivo.trim()
      }, authH());
      setSelectedTicket(res.data);
      toast.success("Ticket reasignado correctamente");
      setShowReassignDialog(false);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al reasignar ticket");
    } finally {
      setReassignLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Fetch usuarios when categoria changes
  const fetchUsuariosCategoria = async (categoriaId) => {
    if (!categoriaId) {
      setUsuariosCategoria([]);
      return;
    }
    try {
      const res = await axios.get(`${API}/tickets/categorias/${categoriaId}/usuarios`, authH());
      setUsuariosCategoria(res.data);
    } catch (err) {
      console.error("Error fetching usuarios:", err);
      setUsuariosCategoria([]);
    }
  };

  // Fetch usuarios by departamento
  const fetchUsuariosDepartamento = async (departamentoId) => {
    if (!departamentoId) {
      setUsuariosDepartamento([]);
      return;
    }
    try {
      const res = await axios.get(`${API}/users`, authH());
      // Filter users by departamento - handle both string and object comparisons
      const filteredUsers = res.data.filter(u => {
        const userDeptId = u.departamento_id || u.department_id || "";
        const isActive = u.is_active !== false && u.activo !== false;
        return userDeptId === departamentoId && isActive;
      });
      console.log(`Found ${filteredUsers.length} users in department ${departamentoId}`);
      setUsuariosDepartamento(filteredUsers);
    } catch (err) {
      console.error("Error fetching usuarios departamento:", err);
      setUsuariosDepartamento([]);
    }
  };

  // Compute allowed assignees according to hierarchy (admin=all, supervisor=their team, regular=none)
  useEffect(() => {
    if (!user) return;
    const role = (user.role || "").toLowerCase();
    const isAdminRole = ["administrador", "admin", "superadmin"].includes(role);
    (async () => {
      try {
        const res = await axios.get(`${API}/users`, authH());
        const allUsers = (Array.isArray(res.data) ? res.data : res.data?.users || []).filter(u => u.is_active !== false);
        if (isAdminRole) {
          setAllowedAssignees(allUsers);
          setCanSeeAsignadoFilter(true);
          return;
        }
        // Check if current user is supervisor of anyone (direct + recursive)
        const supervisedIds = new Set();
        const queue = [user.id];
        const visited = new Set();
        while (queue.length) {
          const current = queue.shift();
          if (visited.has(current)) continue;
          visited.add(current);
          allUsers.forEach(u => {
            if (u.supervisor_id === current && !visited.has(u.id)) {
              supervisedIds.add(u.id);
              queue.push(u.id);
            }
          });
        }
        if (supervisedIds.size > 0) {
          // Include self in the visible list too
          const allowed = allUsers.filter(u => supervisedIds.has(u.id) || u.id === user.id);
          setAllowedAssignees(allowed);
          setCanSeeAsignadoFilter(true);
        } else {
          // Regular ejecutivo — no asignado-filter
          setAllowedAssignees([]);
          setCanSeeAsignadoFilter(false);
        }
      } catch (e) {
        console.error("Error computing allowed assignees:", e);
        setCanSeeAsignadoFilter(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);



  const resetForm = (tipo = "Solicitud") => {
    setFormData({
      titulo: "",
      descripcion: "",
      tipo_ticket: tipo,
      via: tipo === "Oportunidad de Mejora" ? "" : null,
      categoria_id: "",
      sub_categoria: "",
      prioridad: "media",
      prioridad_id: "",
      departamento_id: user?.departamento_id || "",
      solicitante_nombre: user?.name || user?.email?.split('@')[0] || "",
      solicitante_email: user?.email || "",
      solicitante_telefono: user?.telefono || "",
      asignado_a: "",
      archivos_adjuntos: []
    });
    setAttachedFiles([]);
    setUsuariosCategoria([]);
    setUsuariosDepartamento([]);
    setTemplateFields([]);
    setCustomFieldsData({});
    setPlantillasCategoria([]);
  };

  const openNewDialog = () => {
    if (!modulo) {
      // Mesa de Ayuda: sin ventana de elección, todo nuevo ticket es una Solicitud.
      iniciarNuevoTicket("Solicitud");
      return;
    }
    // Paso 1: preguntar qué desea realizar antes de abrir el formulario.
    setShowTypeDialog(true);
  };

  const iniciarNuevoTicket = (tipo) => {
    resetForm(tipo);
    setShowTypeDialog(false);
    setShowDialog(true);
    // Auto-fetch usuarios if user has a department assigned
    if (user?.departamento_id) {
      fetchUsuariosDepartamento(user.departamento_id);
    }
  };

  const iniciarNuevoDetractor = () => {
    // Hallazgos: registrar manualmente un ticket tipo Detractores.
    // El usuario elige el "Departamento a asignar" libremente, igual que en Solicitud.
    iniciarNuevoTicket("Detractores");
  };

  const openDetailDialog = async (ticket) => {
    try {
      const res = await axios.get(`${API}/tickets/${ticket.id}`, authH());
      setSelectedTicket(res.data);
      setShowDetailDialog(true);
    } catch (err) {
      toast.error("Error al cargar el ticket");
    }
  };

  const handleCategoriaChange = async (categoriaId) => {
    setFormData(prev => ({ ...prev, categoria_id: categoriaId, sub_categoria: "", asignado_a: "" }));
    
    // Reset custom fields when category changes
    setTemplateFields([]);
    setCustomFieldsData({});
    
    // Get the category to get its prioridad
    const categoria = categorias.find(c => c.id === categoriaId);
    if (categoria?.prioridad_id) {
      const prio = prioridades.find(p => p.id === categoria.prioridad_id);
      if (prio) {
        setFormData(prev => ({ 
          ...prev, 
          categoria_id: categoriaId,
          sub_categoria: "",
          prioridad_id: prio.id,
          prioridad: prio.name.toLowerCase(),
          asignado_a: ""
        }));
      }
    }
    
    // Fetch usuarios for this categoria (la "Departamento a asignar" define
    // quién puede atender / a quién se asigna el ticket).
    await fetchUsuariosCategoria(categoriaId);

    // Fetch subcategorías disponibles según las reglas y el departamento del
    // usuario que crea el ticket.
    if (categoriaId) {
      try {
        const subRes = await axios.get(`${API}/tickets/subcategorias-disponibles?categoria_id=${categoriaId}`, authH());
        setSubCategoriasDisponibles(subRes.data?.subcategorias || []);
      } catch (err) {
        setSubCategoriasDisponibles([]);
      }
    } else {
      setSubCategoriasDisponibles([]);
    }
    
    // Fetch template(s) for this categoria — se activan según el "activador":
    // las plantillas sin subcategoría activadora se activan al elegir el
    // Departamento a asignar; las que tienen subcategoría activadora se activan
    // cuando el usuario elige esa subcategoría (ver onValueChange de sub_categoria).
    if (categoriaId) {
      setLoadingPlantilla(true);
      try {
        const res = await axios.get(`${API}/plantillas-tickets`, authH());
        const plantillasCat = (res.data || []).filter(p => p.categoria_id === categoriaId);
        setPlantillasCategoria(plantillasCat);
        // Descripción base desde una plantilla sin subcategoría activadora.
        const base = plantillasCat.find(p => !p.subcategoria_activadora && p.contenido);
        if (base) {
          setFormData(prev => ({ ...prev, descripcion: prev.descripcion || base.contenido }));
        }
        const fields = aplicarPlantillas(plantillasCat, "");
        if (fields.length > 0) {
          toast.success(`Plantilla cargada con ${fields.length} campo(s) personalizado(s)`);
        }
      } catch (err) {
        setPlantillasCategoria([]);
        console.log("No se pudieron cargar plantillas para esta categoría");
      } finally {
        setLoadingPlantilla(false);
      }
    } else {
      setPlantillasCategoria([]);
    }
  };

  // Calcula y aplica los campos personalizados activos según la subcategoría.
  const aplicarPlantillas = (plantillas, subCategoria) => {
    const activas = (plantillas || []).filter(p =>
      !p.subcategoria_activadora || p.subcategoria_activadora === subCategoria
    );
    const seen = new Set();
    const fields = [];
    activas.forEach(p => (p.fields || []).forEach(f => {
      const key = f.name || f.id;
      if (!seen.has(key)) { seen.add(key); fields.push(f); }
    }));
    setTemplateFields(fields);
    setCustomFieldsData(prev => {
      const next = {};
      fields.forEach(f => {
        const k = f.name || f.id;
        next[k] = (k in prev) ? prev[k] : (f.default_value || "");
      });
      return next;
    });
    return fields;
  };

  // Handler for custom field value changes
  const handleCustomFieldChange = (fieldKey, value) => {
    setCustomFieldsData(prev => ({
      ...prev,
      [fieldKey]: value
    }));
  };

  // Render a custom field based on its type
  const renderCustomField = (field) => {
    const fieldKey = field.name || field.id;
    const value = customFieldsData[fieldKey] || "";
    const widthClass = field.column_width === "half" ? "col-span-1" : 
                       field.column_width === "third" ? "col-span-1" : "col-span-2";

    switch (field.field_type) {
      case "textarea":
        return (
          <div key={fieldKey} className={widthClass}>
            <Label className="flex items-center gap-1">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
            <Textarea
              value={value}
              onChange={(e) => handleCustomFieldChange(fieldKey, e.target.value)}
              placeholder={field.label}
              className="mt-1 min-h-[80px]"
              data-testid={`custom-field-${fieldKey}`}
            />
          </div>
        );
      case "number":
        return (
          <div key={fieldKey} className={widthClass}>
            <Label className="flex items-center gap-1">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
            <Input
              type="number"
              value={value}
              onChange={(e) => handleCustomFieldChange(fieldKey, e.target.value)}
              placeholder={field.label}
              className="mt-1"
              data-testid={`custom-field-${fieldKey}`}
            />
          </div>
        );
      case "date":
        return (
          <div key={fieldKey} className={widthClass}>
            <Label className="flex items-center gap-1">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
            <Input
              type="date"
              value={value}
              onChange={(e) => handleCustomFieldChange(fieldKey, e.target.value)}
              className="mt-1"
              data-testid={`custom-field-${fieldKey}`}
            />
          </div>
        );
      case "select":
        return (
          <div key={fieldKey} className={widthClass}>
            <Label className="flex items-center gap-1">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
            <Select value={value || "none"} onValueChange={(v) => handleCustomFieldChange(fieldKey, v === "none" ? "" : v)}>
              <SelectTrigger className="mt-1" data-testid={`custom-field-${fieldKey}`}>
                <SelectValue placeholder={`Seleccione ${field.label}`} />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Seleccionar...</SelectItem>
                {(field.options || []).map((opt, idx) => (
                  <SelectItem key={idx} value={opt}>{opt}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        );
      case "checkbox":
        return (
          <div key={fieldKey} className={`${widthClass} flex items-center gap-3 pt-6`}>
            <Checkbox
              id={fieldKey}
              checked={value === "true" || value === true}
              onCheckedChange={(checked) => handleCustomFieldChange(fieldKey, checked)}
              data-testid={`custom-field-${fieldKey}`}
            />
            <Label htmlFor={fieldKey} className="flex items-center gap-1 cursor-pointer">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
          </div>
        );
      default: // text
        return (
          <div key={fieldKey} className={widthClass}>
            <Label className="flex items-center gap-1">
              {field.label}
              {field.required && <span className="text-red-500">*</span>}
            </Label>
            <Input
              value={value}
              onChange={(e) => handleCustomFieldChange(fieldKey, e.target.value)}
              placeholder={field.label}
              className="mt-1"
              data-testid={`custom-field-${fieldKey}`}
            />
          </div>
        );
    }
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    await uploadFiles(Array.from(files));
    // Reset the input so the same file can be selected again
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const uploadFiles = async (files) => {
    setUploadingFile(true);
    
    for (const file of files) {
      // Check file size (15MB max)
      if (file.size > 15 * 1024 * 1024) {
        toast.error(`El archivo "${file.name}" excede 15MB y no se adjuntará`);
        continue;
      }
      
      try {
        const formDataUpload = new FormData();
        formDataUpload.append("file", file);
        
        const res = await axios.post(`${API}/tickets/upload-file`, formDataUpload, {
          ...authH(),
          headers: {
            ...authH().headers,
            "Content-Type": "multipart/form-data"
          }
        });
        
        const newFile = {
          id: res.data.id,
          filename: res.data.filename,
          size: res.data.size,
          url: res.data.url
        };
        
        setAttachedFiles(prev => [...prev, newFile]);
        setFormData(prev => ({
          ...prev,
          archivos_adjuntos: [...prev.archivos_adjuntos, { url: res.data.url, filename: res.data.filename }]
        }));
        
        toast.success(`"${file.name}" adjuntado`);
      } catch (err) {
        toast.error(`Error al subir "${file.name}": ${err.response?.data?.detail || "Error desconocido"}`);
      }
    }
    
    setUploadingFile(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      await uploadFiles(Array.from(files));
    }
  };

  const removeAttachedFile = (index) => {
    setAttachedFiles(prev => prev.filter((_, i) => i !== index));
    setFormData(prev => ({
      ...prev,
      archivos_adjuntos: prev.archivos_adjuntos.filter((_, i) => i !== index)
    }));
  };

  const handleSubmit = async () => {
    if (isSubmittingTicket) return; // Previene doble-submit
    if (!formData.titulo || !formData.descripcion || !formData.solicitante_nombre) {
      toast.error("Complete los campos obligatorios");
      return;
    }

    // Validate asignado_a is required
    if (!formData.asignado_a) {
      toast.error("Debe asignar el ticket a un usuario");
      return;
    }

    // Validate sub_categoria si la categoria lo requiere (solo para Solicitud)
    if (formData.tipo_ticket === "Solicitud" && needsSubCategoria(formData.categoria_id) && !formData.sub_categoria) {
      toast.error("Debe seleccionar una sub-categoría");
      return;
    }

    // Validate required custom fields
    const missingRequiredFields = templateFields
      .filter(f => f.required)
      .filter(f => {
        const fieldKey = f.name || f.id;
        const value = customFieldsData[fieldKey];
        return !value || value === "" || value === "none";
      });
    
    if (missingRequiredFields.length > 0) {
      toast.error(`Campos personalizados requeridos: ${missingRequiredFields.map(f => f.label).join(', ')}`);
      return;
    }

    setIsSubmittingTicket(true);
    try {
      // Include custom fields data in the request
      const ticketData = {
        ...formData,
        custom_fields_data: Object.keys(customFieldsData).length > 0 ? customFieldsData : null
      };
      
      await axios.post(`${API}/tickets`, ticketData, authH());
      toast.success("Ticket creado exitosamente");
      setShowDialog(false);
      resetForm();
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al crear ticket");
    } finally {
      setIsSubmittingTicket(false);
    }
  };

  const updateEstado = async (id, estado, fechaEntrega = null, soporteUrl = null) => {
    try {
      let url = `${API}/tickets/${id}/estado?estado=${estado}`;
      if (fechaEntrega) {
        url += `&fecha_entrega=${encodeURIComponent(fechaEntrega)}`;
      }
      if (soporteUrl) {
        url += `&soporte_entrega_url=${encodeURIComponent(soporteUrl)}`;
      }
      await axios.put(url, {}, authH());
      toast.success(`Estado actualizado a ${estado}`);
      fetchData();
      if (selectedTicket?.id === id) {
        setSelectedTicket({ ...selectedTicket, estado, fecha_entrega: fechaEntrega, soporte_entrega_url: soporteUrl });
      }
    } catch (err) {
      const errorMsg = err.response?.data?.detail || "Error al actualizar estado";
      toast.error(errorMsg);
    }
  };

  const addComentario = async () => {
    if (!nuevoComentario.trim()) return;
    if (sendingComment) return; // guard contra doble-click / Enter mientras corre el request
    // Capturar y limpiar el texto ANTES del request para que cualquier 2do disparo no envíe el mismo contenido
    const texto = nuevoComentario.trim();
    setNuevoComentario("");
    setSendingComment(true);
    try {
      await axios.post(`${API}/tickets/${selectedTicket.id}/comentarios?texto=${encodeURIComponent(texto)}`, {}, authH());
      toast.success("Comentario agregado");
      const res = await axios.get(`${API}/tickets/${selectedTicket.id}`, authH());
      setSelectedTicket(res.data);
    } catch (err) {
      // Si falla, restaurar el texto para que el usuario pueda reintentar
      setNuevoComentario(texto);
      toast.error("Error al agregar comentario");
    } finally {
      setSendingComment(false);
    }
  };

  const attachSupportFiles = async (fileList) => {
    if (!selectedTicket || !fileList || fileList.length === 0) return;
    const fd = new FormData();
    Array.from(fileList).forEach((f) => fd.append("files", f));
    setAttachingSupport(true);
    try {
      const auth = authH();
      await axios.post(`${API}/tickets/${selectedTicket.id}/adjuntar-archivos`, fd, {
        headers: { ...auth.headers, "Content-Type": "multipart/form-data" },
      });
      toast.success("Archivo(s) adjuntado(s) al ticket");
      const res = await axios.get(`${API}/tickets/${selectedTicket.id}`, authH());
      setSelectedTicket(res.data);
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Error al adjuntar archivos");
    } finally {
      setAttachingSupport(false);
      if (supportFileRef.current) supportFileRef.current.value = "";
    }
  };


  const deleteTicket = async (id) => {
    if (!window.confirm("¿Eliminar este ticket?")) return;
    try {
      await axios.delete(`${API}/tickets/${id}`, authH());
      toast.success("Ticket eliminado");
      fetchData();
    } catch (err) {
      toast.error("Error al eliminar");
    }
  };

  const formatFileSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  };

  const getPrioridadBadge = (prioridad, color) => {
    const defaultStyles = {
      baja: "bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300",
      media: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
      alta: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
      critica: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300",
      crítica: "bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300"
    };
    
    if (color) {
      return (
        <Badge 
          className="border-0 uppercase text-xs text-white"
          style={{ backgroundColor: color }}
        >
          {prioridad}
        </Badge>
      );
    }
    
    return <Badge className={`${defaultStyles[prioridad?.toLowerCase()] || defaultStyles.media} border-0 uppercase text-xs`}>{prioridad}</Badge>;
  };

  const getEstadoBadge = (estado) => {
    const styles = {
      abierto: "bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300",
      en_progreso: "bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-300",
      pendiente: "bg-orange-100 text-orange-700 dark:bg-orange-900/30 dark:text-orange-300",
      resuelto: "bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-300",
      cerrado: "bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300",
      completado: "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300"
    };
    const labels = {
      abierto: "Abierto",
      en_progreso: "En Progreso",
      pendiente: "Pendiente",
      resuelto: "Resuelto",
      cerrado: "Cerrado",
      completado: "Completado"
    };
    return <Badge className={`${styles[estado] || styles.abierto} border-0`}>{labels[estado] || estado}</Badge>;
  };

  const filteredTickets = tickets.filter(t => {
    const matchesSearch = 
      t.titulo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.numero?.toString().includes(searchQuery) ||
      t.solicitante_nombre?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesEstado = estadoFilter === "all" || t.estado === estadoFilter;
    const matchesEstatusFinal = !modulo || estatusFinalFilter === "all"
      || (estatusFinalFilter === "cerrado_conforme" && t.estatus_final === "Cerrado Conforme")
      || (estatusFinalFilter === "reabierto" && t.estatus_final !== "Cerrado Conforme"
          && !["resuelto", "cerrado", "completado"].includes(t.estado)
          && (t.historial_estados || []).some(h => (h.detalle || "").startsWith("Reabierto por No Cumple")));
    const matchesPrioridad = prioridadFilter === "all" || t.prioridad?.toLowerCase() === prioridadFilter;
    const matchesCategoria = categoriaFilter === "all" || t.categoria_id === categoriaFilter;
    const matchesSubCategoria = subCategoriaFilter === "all" || (t.sub_categoria || "") === subCategoriaFilter;
    const matchesDeptCreador = departamentoCreadorFilter === "all" || t.departamento_creador_id === departamentoCreadorFilter;
    const matchesTipo = tipoFilter === "all" || (t.tipo_ticket || "Solicitud") === tipoFilter;
    const matchesVia = viaFilter === "all" || (t.via || "") === viaFilter;
    const matchesAsignadoAMi = !asignadoAMiFilter || t.asignado_a === user?.id;
    const matchesAsignadoUser = asignadoUserFilter === "all" || t.asignado_a === asignadoUserFilter;

    let matchesFechas = true;
    if (fechaDesde || fechaHasta) {
      const fc = t.fecha_creacion ? new Date(t.fecha_creacion) : null;
      if (!fc || isNaN(fc.getTime())) {
        matchesFechas = false;
      } else {
        if (fechaDesde) {
          const desde = new Date(fechaDesde + "T00:00:00");
          if (fc < desde) matchesFechas = false;
        }
        if (matchesFechas && fechaHasta) {
          const hasta = new Date(fechaHasta + "T23:59:59.999");
          if (fc > hasta) matchesFechas = false;
        }
      }
    }

    return matchesSearch && matchesEstado && matchesPrioridad && matchesCategoria && matchesSubCategoria && matchesDeptCreador && matchesTipo && matchesVia && matchesFechas && matchesAsignadoAMi && matchesAsignadoUser && matchesEstatusFinal && (slaFilter === "all" || slaSemaforo(t)?.key === slaFilter);
  });

  // Tickets que cumplen TODOS los filtros activos EXCEPTO el de estado.
  // Se usa para que las tarjetas KPI reflejen el desglose por estado dentro
  // del alcance del filtro seleccionado (departamento/categoría/fechas/etc.).
  const cardScopedTickets = tickets.filter(t => {
    const matchesSearch =
      t.titulo?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      t.numero?.toString().includes(searchQuery) ||
      t.solicitante_nombre?.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesPrioridad = prioridadFilter === "all" || t.prioridad?.toLowerCase() === prioridadFilter;
    const matchesCategoria = categoriaFilter === "all" || t.categoria_id === categoriaFilter;
    const matchesSubCategoria = subCategoriaFilter === "all" || (t.sub_categoria || "") === subCategoriaFilter;
    const matchesDeptCreador = departamentoCreadorFilter === "all" || t.departamento_creador_id === departamentoCreadorFilter;
    const matchesTipo = tipoFilter === "all" || (t.tipo_ticket || "Solicitud") === tipoFilter;
    const matchesVia = viaFilter === "all" || (t.via || "") === viaFilter;
    const matchesAsignadoAMi = !asignadoAMiFilter || t.asignado_a === user?.id;
    const matchesAsignadoUser = asignadoUserFilter === "all" || t.asignado_a === asignadoUserFilter;
    const matchesEstatusFinal = !modulo || estatusFinalFilter === "all"
      || (estatusFinalFilter === "cerrado_conforme" && t.estatus_final === "Cerrado Conforme")
      || (estatusFinalFilter === "reabierto" && t.estatus_final !== "Cerrado Conforme"
          && !["resuelto", "cerrado", "completado"].includes(t.estado)
          && (t.historial_estados || []).some(h => (h.detalle || "").startsWith("Reabierto por No Cumple")));

    let matchesFechas = true;
    if (fechaDesde || fechaHasta) {
      const fc = t.fecha_creacion ? new Date(t.fecha_creacion) : null;
      if (!fc || isNaN(fc.getTime())) {
        matchesFechas = false;
      } else {
        if (fechaDesde) {
          const desde = new Date(fechaDesde + "T00:00:00");
          if (fc < desde) matchesFechas = false;
        }
        if (matchesFechas && fechaHasta) {
          const hasta = new Date(fechaHasta + "T23:59:59.999");
          if (fc > hasta) matchesFechas = false;
        }
      }
    }
    return matchesSearch && matchesPrioridad && matchesCategoria && matchesSubCategoria && matchesDeptCreador && matchesTipo && matchesVia && matchesFechas && matchesAsignadoAMi && matchesAsignadoUser && matchesEstatusFinal;
  });

  // ¿Hay algún filtro distinto al de estado activo? (controla si las tarjetas
  // muestran el conteo filtrado o el total global del backend).
  const hasScopeFilter =
    !!searchQuery ||
    prioridadFilter !== "all" ||
    categoriaFilter !== "all" ||
    subCategoriaFilter !== "all" ||
    departamentoCreadorFilter !== "all" ||
    asignadoAMiFilter ||
    asignadoUserFilter !== "all" ||
    !!fechaDesde ||
    !!fechaHasta;

  // Reabierto por No Cumple y aún no re-cerrado por el usuario
  const esReabierto = (t) => t.estatus_final !== "Cerrado Conforme"
    && !["resuelto", "cerrado", "completado"].includes(t.estado)
    && (t.historial_estados || []).some(h => (h.detalle || "").startsWith("Reabierto por No Cumple"));

  const cardStats = hasScopeFilter
    ? {
        total: cardScopedTickets.length,
        abiertos: cardScopedTickets.filter(t => t.estado === "abierto").length,
        en_progreso: cardScopedTickets.filter(t => t.estado === "en_progreso").length,
        pendientes: cardScopedTickets.filter(t => t.estado === "pendiente").length,
        resueltos: cardScopedTickets.filter(t => t.estado === "resuelto").length,
        cerrado_conforme: cardScopedTickets.filter(t => t.estatus_final === "Cerrado Conforme").length,
        reabiertos: cardScopedTickets.filter(esReabierto).length,
      }
    : {
        total: stats.total || 0,
        abiertos: stats.abiertos || 0,
        en_progreso: stats.en_progreso || 0,
        pendientes: stats.pendientes || 0,
        resueltos: stats.resueltos || 0,
        cerrado_conforme: tickets.filter(t => t.estatus_final === "Cerrado Conforme").length,
        reabiertos: tickets.filter(esReabierto).length,
      };

  // Exportar a Excel los tickets actualmente visualizados (filtrados)
  const exportToExcel = async () => {
    if (filteredTickets.length === 0) {
      toast.error("No hay tickets para exportar con los filtros actuales");
      return;
    }
    setExportingExcel(true);
    try {
      const ticket_ids = filteredTickets.map(t => t.id);
      const auth = authH();
      const response = await axios.post(
        `${API}/tickets/exportar-excel`,
        { ticket_ids },
        { ...auth, responseType: "blob" }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const ts = new Date().toISOString().slice(0, 16).replace(/[:T]/g, "");
      a.download = `Mesa_Ayuda_Tickets_${ts}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success(`Reporte exportado (${filteredTickets.length} ticket${filteredTickets.length === 1 ? "" : "s"})`);
    } catch (err) {
      console.error("Error exporting excel:", err);
      toast.error(err?.response?.data?.detail || "Error al exportar reporte");
    } finally {
      setExportingExcel(false);
    }
  };

  const limpiarFiltros = () => {
    setSearchQuery("");
    setEstadoFilter("all");
    setPrioridadFilter("all");
    setCategoriaFilter("all");
    setSubCategoriaFilter("all");
    setTipoFilter("all");
    setViaFilter("all");
    setFechaDesde("");
    setFechaHasta("");
    setActiveFilterColumn("");
    setActiveFilterValue("");
    setAsignadoAMiFilter(false);
    setAsignadoUserFilter("all");
    setSlaFilter("all");
  };
  const filtrosActivos = (
    !!searchQuery || estadoFilter !== "all" || prioridadFilter !== "all" ||
    categoriaFilter !== "all" || subCategoriaFilter !== "all" || tipoFilter !== "all" ||
    viaFilter !== "all" || !!fechaDesde || !!fechaHasta ||
    asignadoAMiFilter || asignadoUserFilter !== "all" || slaFilter !== "all"
  );

  return (
    <div className={embedded ? "flex" : "flex min-h-screen bg-slate-50 dark:bg-slate-900"}>
      {!embedded && <Sidebar />}
      
      <main className={`flex-1 p-4 md:p-8 pt-0 md:pt-0 overflow-x-clip ${embedded ? "" : "ml-0 md:ml-64"}`} data-testid="tickets-page">
        {/* STICKY HEADER - se mantiene fijo al hacer scroll */}
        <div className="sticky top-0 z-20 bg-slate-50 dark:bg-slate-900 -mx-4 md:-mx-8 px-4 md:px-8 pt-14 md:pt-8 pb-4 border-b border-slate-200 dark:border-slate-700" data-testid="tickets-sticky-header">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-3xl font-bold text-slate-900 dark:text-white font-['Manrope']">
              {modulo ? "Hallazgos Auditoria" : "Mesa de Ayuda"}
            </h1>
            <p className="text-slate-500 dark:text-slate-400 mt-1">
              {modulo ? "Gestiona hallazgos de auditoría" : "Gestiona tickets de soporte"}
            </p>
          </div>
          <Button onClick={openNewDialog} className="bg-[#0C314C] hover:bg-[#2a4d7a] text-white" data-testid="new-ticket-btn">
            <Plus className="w-4 h-4 mr-2" />
            {modulo ? "Nuevo Hallazgo" : "Nuevo Ticket"}
          </Button>
        </div>

        {/* Tabs: Tickets | Estadísticas (estadísticas solo para supervisores/admins) */}
        <div className="flex gap-1 mb-6 border-b border-slate-200 dark:border-slate-700">
          <button
            onClick={() => setActiveTab("tickets")}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${activeTab === "tickets" ? "border-[#0C314C] text-[#0C314C] dark:border-blue-400 dark:text-blue-400" : "border-transparent text-slate-500 hover:text-slate-700"}`}
            data-testid="tickets-tab-tickets"
          >
            Tickets
          </button>
          {/* Estadísticas: visible para todos; el backend limita los datos según el rol */}
          <button
              onClick={() => setActiveTab("stats")}
              className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${activeTab === "stats" ? "border-[#0C314C] text-[#0C314C] dark:border-blue-400 dark:text-blue-400" : "border-transparent text-slate-500 hover:text-slate-700"}`}
              data-testid="tickets-tab-stats"
            >
              Estadísticas
            </button>
          <button
            onClick={() => setActiveTab("reasignados")}
            className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${activeTab === "reasignados" ? "border-[#0C314C] text-[#0C314C] dark:border-blue-400 dark:text-blue-400" : "border-transparent text-slate-500 hover:text-slate-700"}`}
            data-testid="tickets-tab-reasignados"
          >
            Tickets Reasignados
          </button>
          {modulo === "hallazgos_auditoria" && ["administrador", "admin", "superadmin"].includes((user?.role || "").toLowerCase()) && (
            <button
              onClick={() => setActiveTab("configuracion")}
              className={`px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors ${activeTab === "configuracion" ? "border-[#0C314C] text-[#0C314C] dark:border-blue-400 dark:text-blue-400" : "border-transparent text-slate-500 hover:text-slate-700"}`}
              data-testid="tickets-tab-configuracion"
            >
              Configuración
            </button>
          )}
        </div>

        {activeTab === "tickets" && (
        <>
        {/* Stats - Clickable filters (se ajustan a los filtros activos) */}
        {hasScopeFilter && (
          <div className="mb-3 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400" data-testid="tickets-cards-scope-note">
            <Filter className="w-3.5 h-3.5" />
            <span>Las tarjetas reflejan los <strong className="text-slate-700 dark:text-slate-200">filtros activos</strong></span>
          </div>
        )}
        <div className="kpi-carousel grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-8">
          <Card
            className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-800 dark:to-slate-800/60 ${estadoFilter === "all" ? "ring-2 ring-slate-400 shadow-md" : ""}`}
            onClick={() => { setEstadoFilter("all"); }}
            data-testid="tickets-card-total"
          >
            <span className="absolute left-0 top-0 h-full w-1.5 bg-slate-400" />
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-slate-500 dark:text-slate-400">Total</p>
                  <p className="text-3xl font-bold text-slate-900 dark:text-white">{cardStats.total}</p>
                </div>
                <div className="p-2.5 rounded-xl bg-slate-200/70 dark:bg-slate-700">
                  <Ticket className="w-6 h-6 text-slate-600 dark:text-slate-300" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card
            className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-blue-50 to-blue-100/60 dark:from-blue-900/30 dark:to-blue-900/10 ${estadoFilter === "abierto" ? "ring-2 ring-blue-500 shadow-md" : ""}`}
            onClick={() => { setEstadoFilter("abierto"); }}
            data-testid="tickets-card-abiertos"
          >
            <span className="absolute left-0 top-0 h-full w-1.5 bg-blue-500" />
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-blue-700/70 dark:text-blue-300/70">Abiertos</p>
                  <p className="text-3xl font-bold text-blue-600 dark:text-blue-400">{cardStats.abiertos}</p>
                </div>
                <div className="p-2.5 rounded-xl bg-blue-500/15 dark:bg-blue-500/20">
                  <AlertTriangle className="w-6 h-6 text-blue-600 dark:text-blue-400" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card
            className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-yellow-50 to-amber-100/60 dark:from-yellow-900/30 dark:to-amber-900/10 ${estadoFilter === "en_progreso" ? "ring-2 ring-yellow-500 shadow-md" : ""}`}
            onClick={() => { setEstadoFilter("en_progreso"); }}
            data-testid="tickets-card-en-progreso"
          >
            <span className="absolute left-0 top-0 h-full w-1.5 bg-yellow-500" />
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-yellow-700/70 dark:text-yellow-300/70">En Progreso</p>
                  <p className="text-3xl font-bold text-yellow-600 dark:text-yellow-400">{cardStats.en_progreso}</p>
                </div>
                <div className="p-2.5 rounded-xl bg-yellow-500/15 dark:bg-yellow-500/20">
                  <Clock className="w-6 h-6 text-yellow-600 dark:text-yellow-400" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card
            className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-orange-50 to-orange-100/60 dark:from-orange-900/30 dark:to-orange-900/10 ${estadoFilter === "pendiente" ? "ring-2 ring-orange-500 shadow-md" : ""}`}
            onClick={() => { setEstadoFilter("pendiente"); }}
            data-testid="tickets-card-pendientes"
          >
            <span className="absolute left-0 top-0 h-full w-1.5 bg-orange-500" />
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-orange-700/70 dark:text-orange-300/70">Pendientes</p>
                  <p className="text-3xl font-bold text-orange-600 dark:text-orange-400">{cardStats.pendientes}</p>
                </div>
                <div className="p-2.5 rounded-xl bg-orange-500/15 dark:bg-orange-500/20">
                  <AlertCircle className="w-6 h-6 text-orange-600 dark:text-orange-400" />
                </div>
              </div>
            </CardContent>
          </Card>
          <Card
            className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-green-50 to-emerald-100/60 dark:from-green-900/30 dark:to-emerald-900/10 ${estadoFilter === "resuelto" ? "ring-2 ring-green-500 shadow-md" : ""}`}
            onClick={() => { setEstadoFilter("resuelto"); }}
            data-testid="tickets-card-resueltos"
          >
            <span className="absolute left-0 top-0 h-full w-1.5 bg-green-500" />
            <CardContent className="pt-6">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-green-700/70 dark:text-green-300/70">Resueltos</p>
                  <p className="text-3xl font-bold text-green-600 dark:text-green-400">{cardStats.resueltos}</p>
                </div>
                <div className="p-2.5 rounded-xl bg-green-500/15 dark:bg-green-500/20">
                  <CheckCircle2 className="w-6 h-6 text-green-600 dark:text-green-400" />
                </div>
              </div>
            </CardContent>
          </Card>
          {modulo && (
            <Card
              className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-emerald-50 to-teal-100/60 dark:from-emerald-900/30 dark:to-teal-900/10 ${estatusFinalFilter === "cerrado_conforme" ? "ring-2 ring-emerald-600 shadow-md" : ""}`}
              onClick={() => setEstatusFinalFilter(estatusFinalFilter === "cerrado_conforme" ? "all" : "cerrado_conforme")}
              data-testid="tickets-card-cerrado-conforme"
            >
              <span className="absolute left-0 top-0 h-full w-1.5 bg-emerald-600" />
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-emerald-700/70 dark:text-emerald-300/70">Cerrado Conforme</p>
                    <p className="text-3xl font-bold text-emerald-700 dark:text-emerald-400">{cardStats.cerrado_conforme}</p>
                  </div>
                  <div className="p-2.5 rounded-xl bg-emerald-600/15 dark:bg-emerald-500/20">
                    <ShieldCheck className="w-6 h-6 text-emerald-700 dark:text-emerald-400" />
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
          {modulo && (
            <Card
              className={`relative overflow-hidden cursor-pointer transition-all duration-200 hover:shadow-lg hover:-translate-y-0.5 border-0 bg-gradient-to-br from-red-50 to-rose-100/60 dark:from-red-900/30 dark:to-rose-900/10 ${estatusFinalFilter === "reabierto" ? "ring-2 ring-red-500 shadow-md" : ""}`}
              onClick={() => setEstatusFinalFilter(estatusFinalFilter === "reabierto" ? "all" : "reabierto")}
              data-testid="tickets-card-reabiertos"
            >
              <span className="absolute left-0 top-0 h-full w-1.5 bg-red-500" />
              <CardContent className="pt-6">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-red-700/70 dark:text-red-300/70">Reabiertos</p>
                    <p className="text-3xl font-bold text-red-600 dark:text-red-400">{cardStats.reabiertos}</p>
                  </div>
                  <div className="p-2.5 rounded-xl bg-red-500/15 dark:bg-red-500/20">
                    <RotateCcw className="w-6 h-6 text-red-600 dark:text-red-400" />
                  </div>
                </div>
              </CardContent>
            </Card>
          )}
        </div>

        {/* Filters - Grouped Single Selector (UX como Control de Renovaciones) */}
        <div className="flex flex-wrap gap-3 mb-6 items-end">
          <div className="relative flex-1 min-w-[220px] max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-slate-400" />
            <Input
              placeholder="Buscar tickets..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10"
              data-testid="tickets-search-input"
            />
          </div>

          {/* All filter fields visible & combinable */}
          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Estado</Label>
            <SearchableSelect
              value={estadoFilter === "all" ? "ALL" : estadoFilter}
              onValueChange={(v) => setEstadoFilter(!v || v === "ALL" ? "all" : v)}
              options={[
                { value: "abierto", label: "Abierto" },
                { value: "en_progreso", label: "En Progreso" },
                { value: "pendiente", label: "Pendiente" },
                { value: "resuelto", label: "Resuelto" },
                ...(userIsAdmin() ? [
                  { value: "cerrado", label: "Cerrado" },
                  { value: "completado", label: "Completado" },
                ] : []),
              ]}
              allLabel="Todos"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-36"
              data-testid="tickets-filter-estado-value"
            />
          </div>

          {modulo && (
          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Estatus Final</Label>
            <SearchableSelect
              value={estatusFinalFilter === "all" ? "ALL" : estatusFinalFilter}
              onValueChange={(v) => setEstatusFinalFilter(!v || v === "ALL" ? "all" : v)}
              options={[
                { value: "cerrado_conforme", label: "Cerrado Conforme" },
                { value: "reabierto", label: "Reabiertos (No Cumple)" },
              ]}
              allLabel="Todos"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-44"
              data-testid="tickets-filter-estatus-final-value"
            />
          </div>
          )}

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Prioridad</Label>
            <SearchableSelect
              value={prioridadFilter === "all" ? "ALL" : prioridadFilter}
              onValueChange={(v) => setPrioridadFilter(!v || v === "ALL" ? "all" : v)}
              options={[
                { value: "critica", label: "Crítica" },
                { value: "alta", label: "Alta" },
                { value: "media", label: "Media" },
                { value: "baja", label: "Baja" },
              ]}
              allLabel="Todas"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-32"
              data-testid="tickets-filter-prioridad-value"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Tipo</Label>
            <SearchableSelect
              value={tipoFilter === "all" ? "ALL" : tipoFilter}
              onValueChange={(v) => setTipoFilter(!v || v === "ALL" ? "all" : v)}
              options={modulo ? [
                { value: "Solicitud", label: "Solicitud" },
                { value: "Queja Cliente", label: "Queja Cliente" },
                { value: "Oportunidad de Mejora", label: "Oportunidad de Mejora" },
                { value: "Detractores", label: "Detractores" },
              ] : [
                { value: "Solicitud", label: "Solicitud" },
                { value: "Queja Cliente", label: "Queja Cliente" },
                { value: "Oportunidad de Mejora", label: "Oportunidad de Mejora" },
              ]}
              allLabel="Todos"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-44"
              data-testid="tickets-filter-tipo-value"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Vía</Label>
            <SearchableSelect
              value={viaFilter === "all" ? "ALL" : viaFilter}
              onValueChange={(v) => setViaFilter(!v || v === "ALL" ? "all" : v)}
              options={[
                { value: "Internas", label: "Internas" },
                { value: "Externas", label: "Externas" },
              ]}
              allLabel="Todas"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-32"
              data-testid="tickets-filter-via-value"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Departamento a asignar</Label>
            <SearchableSelect
              value={categoriaFilter === "all" ? "ALL" : categoriaFilter}
              onValueChange={(v) => { setCategoriaFilter(!v || v === "ALL" ? "all" : v); setSubCategoriaFilter("all"); }}
              options={categorias.map(c => ({ value: c.id, label: c.name }))}
              allLabel="Todas"
              searchPlaceholder="Buscar categoría..."
              emptyText="No encontrado."
              triggerClassName="w-44"
              data-testid="tickets-filter-categoria-value"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Departamento que asigna</Label>
            <SearchableSelect
              value={departamentoCreadorFilter === "all" ? "ALL" : departamentoCreadorFilter}
              onValueChange={(v) => setDepartamentoCreadorFilter(!v || v === "ALL" ? "all" : v)}
              options={departamentos.map(d => ({ value: d.id, label: d.name }))}
              allLabel="Todos"
              searchPlaceholder="Buscar departamento..."
              emptyText="No encontrado."
              triggerClassName="w-44"
              data-testid="tickets-filter-departamento-creador-value"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Sub-categoría</Label>
            <SearchableSelect
              value={subCategoriaFilter === "all" ? "ALL" : subCategoriaFilter}
              onValueChange={(v) => setSubCategoriaFilter(!v || v === "ALL" ? "all" : v)}
              options={(() => {
                // Opciones dinámicas: se actualizan al crear/eliminar subcategorías
                // en la pestaña "Sub categorías". Si hay un "Departamento a asignar"
                // seleccionado, se filtran a las subcategorías de esa categoría.
                let configuradas = [];
                if (categoriaFilter !== "all") {
                  configuradas = reglasSubcat
                    .filter(r => r.categoria_id === categoriaFilter)
                    .flatMap(r => r.subcategorias || []);
                  if (isRiesgosGenerales(categoriaFilter)) configuradas = [...configuradas, ...SUB_CATEGORIAS_RIESGOS];
                } else {
                  configuradas = reglasSubcat.flatMap(r => r.subcategorias || []);
                }
                // Incluir subcategorías presentes en tickets (respeta categoría si está filtrada)
                const fromData = tickets
                  .filter(t => categoriaFilter === "all" || t.categoria_id === categoriaFilter)
                  .map(t => t.sub_categoria)
                  .filter(Boolean);
                const merged = [...new Set([...configuradas, ...fromData])];
                return merged.sort().map(s => ({ value: s, label: s }));
              })()}
              allLabel="Todas"
              searchPlaceholder="Buscar..."
              emptyText="No encontrado."
              triggerClassName="w-44"
              data-testid="tickets-filter-subcategoria-value"
            />
          </div>

          {canSeeAsignadoFilter && (
            <div className="flex flex-col gap-1">
              <Label className="text-[10px] uppercase tracking-wide text-slate-500">Asignado a</Label>
              <SearchableSelect
                value={asignadoUserFilter === "all" ? "ALL" : asignadoUserFilter}
                onValueChange={(v) => setAsignadoUserFilter(!v || v === "ALL" ? "all" : v)}
                options={allowedAssignees
                  .map(u => ({ value: u.id, label: u.name }))
                  .sort((a, b) => a.label.localeCompare(b.label))
                }
                allLabel="Todos"
                searchPlaceholder="Buscar usuario..."
                emptyText="Sin usuarios."
                triggerClassName="w-44"
                data-testid="tickets-filter-asignado-value"
              />
            </div>
          )}

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Desde</Label>
            <Input
              type="date"
              value={fechaDesde}
              onChange={(e) => setFechaDesde(e.target.value)}
              className="w-36"
              data-testid="tickets-fecha-desde"
            />
          </div>

          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">Hasta</Label>
            <Input
              type="date"
              value={fechaHasta}
              onChange={(e) => setFechaHasta(e.target.value)}
              className="w-36"
              data-testid="tickets-fecha-hasta"
            />
          </div>

          {/* Filtro por semáforo SLA */}
          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">SLA</Label>
            <div className="flex items-center gap-1" data-testid="tickets-sla-filter">
              {[
                { key: "all", label: "Todos", dot: null },
                { key: "verde", label: "En tiempo", dot: "bg-green-500" },
                { key: "ambar", label: "Por vencer", dot: "bg-amber-500" },
                { key: "rojo", label: "Vencidos", dot: "bg-red-500" },
              ].map((o) => {
                const activo = slaFilter === o.key;
                return (
                  <button
                    key={o.key}
                    type="button"
                    onClick={() => setSlaFilter(activo && o.key !== "all" ? "all" : o.key)}
                    title={o.key === "all" ? "Mostrar todos" : `Mostrar solo tickets con SLA ${o.label.toLowerCase()}`}
                    className={`inline-flex items-center gap-1.5 px-2.5 h-9 rounded-md border text-xs font-medium transition-all ${
                      activo
                        ? "bg-[#0C314C] text-white border-[#0C314C] shadow"
                        : "bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700 hover:shadow"
                    }`}
                    data-testid={`tickets-sla-filter-${o.key}`}
                  >
                    {o.dot && <span className={`w-2.5 h-2.5 rounded-full ${o.dot}`} />}
                    {o.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Toggle "Asignados a mí" */}
          <div className="flex flex-col gap-1">
            <Label className="text-[10px] uppercase tracking-wide text-slate-500">&nbsp;</Label>
            <Button
              type="button"
              variant={asignadoAMiFilter ? "default" : "outline"}
              onClick={() => setAsignadoAMiFilter(v => !v)}
              className={asignadoAMiFilter
                ? "bg-emerald-600 hover:bg-emerald-700 text-white"
                : "border-emerald-300 text-emerald-700 hover:bg-emerald-50"}
              data-testid="tickets-asignados-ami-toggle"
              title="Mostrar solo tickets asignados a mi usuario"
            >
              <UserCheck className="w-4 h-4 mr-1" />
              Asignados a mí
            </Button>
          </div>

          {filtrosActivos && (
            <Button
              variant="ghost"
              onClick={limpiarFiltros}
              className="text-slate-600 dark:text-slate-300"
              data-testid="tickets-limpiar-filtros-btn"
            >
              <X className="w-4 h-4 mr-1" />
              Limpiar
            </Button>
          )}
          {canExportTickets() && (
            <Button
              variant="outline"
              onClick={exportToExcel}
              disabled={exportingExcel || filteredTickets.length === 0}
              className="border-emerald-300 text-emerald-700 hover:bg-emerald-50 dark:border-emerald-700 dark:text-emerald-300 dark:hover:bg-emerald-900/20"
              data-testid="tickets-exportar-excel-btn"
            >
              {exportingExcel
                ? <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                : <FileDown className="w-4 h-4 mr-1" />}
              Exportar Excel ({filteredTickets.length})
            </Button>
          )}
          <ViewSelector currentView={viewMode} onViewChange={setViewMode} />
        </div>

        {/* Active filters badges */}
        {(estadoFilter !== "all" || prioridadFilter !== "all" || categoriaFilter !== "all" || subCategoriaFilter !== "all" || fechaDesde || fechaHasta) && (
          <div className="flex flex-wrap gap-2 mb-4" data-testid="tickets-active-filter-badges">
            {estadoFilter !== "all" && (
              <Badge variant="secondary" className="bg-blue-100 text-blue-700 flex items-center gap-1 text-xs">
                Estado: {estadoFilter}
                <button onClick={() => { setEstadoFilter("all"); if (activeFilterColumn === "estado") setActiveFilterValue(""); }} className="ml-1">✕</button>
              </Badge>
            )}
            {prioridadFilter !== "all" && (
              <Badge variant="secondary" className="bg-amber-100 text-amber-700 flex items-center gap-1 text-xs">
                Prioridad: {prioridadFilter}
                <button onClick={() => { setPrioridadFilter("all"); if (activeFilterColumn === "prioridad") setActiveFilterValue(""); }} className="ml-1">✕</button>
              </Badge>
            )}
            {categoriaFilter !== "all" && (
              <Badge variant="secondary" className="bg-purple-100 text-purple-700 flex items-center gap-1 text-xs">
                Departamento a asignar: {categorias.find(c => c.id === categoriaFilter)?.name || categoriaFilter}
                <button onClick={() => { setCategoriaFilter("all"); if (activeFilterColumn === "categoria") setActiveFilterValue(""); }} className="ml-1">✕</button>
              </Badge>
            )}
            {subCategoriaFilter !== "all" && (
              <Badge variant="secondary" className="bg-indigo-100 text-indigo-700 flex items-center gap-1 text-xs">
                Sub-categoría: {subCategoriaFilter}
                <button onClick={() => { setSubCategoriaFilter("all"); if (activeFilterColumn === "sub_categoria") setActiveFilterValue(""); }} className="ml-1">✕</button>
              </Badge>
            )}
            {(fechaDesde || fechaHasta) && (
              <Badge variant="secondary" className="bg-rose-100 text-rose-700 flex items-center gap-1 text-xs">
                Fecha: {fechaDesde || "..."} - {fechaHasta || "..."}
                <button onClick={() => { setFechaDesde(""); setFechaHasta(""); }} className="ml-1">✕</button>
              </Badge>
            )}
          </div>
        )}

        {/* FIN STICKY HEADER (parte de tickets) */}
        </>
        )}
        </div>
        {/* FIN STICKY HEADER */}

        {activeTab === "stats" && <TicketsStatsTab modulo={modulo} />}
        {activeTab === "reasignados" && <TicketsReasignadosTab modulo={modulo} />}
        {activeTab === "configuracion" && modulo === "hallazgos_auditoria" && <HallazgosConfigTitulosTab />}

        {activeTab === "tickets" && (
        <div className="pt-4">
        {/* Tickets Content - Multiple Views */}
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader2 className="w-8 h-8 animate-spin text-slate-400" />
          </div>
        ) : filteredTickets.length === 0 ? (
          <Card className="border-slate-200 dark:border-slate-700 dark:bg-slate-800">
            <CardContent className="py-12 text-center">
              <Ticket className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto mb-4" />
              <p className="text-slate-500 dark:text-slate-400">No hay tickets</p>
            </CardContent>
          </Card>
        ) : viewMode === 'kanban' ? (
          <KanbanView 
            items={filteredTickets}
            columns={[
              { id: 'pendiente', label: 'Abierto / Pendiente', color: 'bg-yellow-500' },
              { id: 'en_proceso', label: 'En Progreso', color: 'bg-blue-500' },
              { id: 'completado', label: 'Resuelto', color: 'bg-green-500' },
            ]}
            statusField="estado"
            renderCard={(ticket) => (
              <div>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs text-slate-500">#{ticket.numero}</span>
                  <Badge variant="outline" className={`text-xs ${
                    ticket.prioridad === 'critica' ? 'border-red-300 text-red-600' :
                    ticket.prioridad === 'alta' ? 'border-orange-300 text-orange-600' :
                    'border-slate-300 text-slate-600'
                  }`}>
                    {ticket.prioridad}
                  </Badge>
                </div>
                <p className="font-medium text-sm text-slate-900 dark:text-white line-clamp-2">{ticket.titulo}</p>
                <p className="text-xs text-slate-500 mt-1">{ticket.solicitante_nombre}</p>
              </div>
            )}
            onItemClick={(ticket) => openDetailDialog(ticket)}
          />
        ) : viewMode === 'cards' ? (
          <CardsView
            items={filteredTickets}
            columns={3}
            renderCard={(ticket) => (
              <>
                <CardHeader className="pb-2">
                  <div className="flex items-center justify-between">
                    <Badge variant="outline" className="text-xs">#{ticket.numero}</Badge>
                    <Badge className={`text-xs ${
                      ticket.estado === 'resuelto' || ticket.estado === 'completado' ? 'bg-green-100 text-green-700' :
                      ticket.estado === 'en_progreso' ? 'bg-blue-100 text-blue-700' :
                      'bg-yellow-100 text-yellow-700'
                    }`}>
                      {ticket.estado}
                    </Badge>
                  </div>
                  <CardTitle className="text-base mt-2">{ticket.titulo}</CardTitle>
                </CardHeader>
                <CardContent className="pb-2">
                  <p className="text-sm text-slate-600 dark:text-slate-300 line-clamp-2">{ticket.descripcion}</p>
                  <div className="flex items-center gap-2 mt-3 text-xs text-slate-500">
                    <User className="w-3 h-3" />
                    <span>{ticket.solicitante_nombre}</span>
                  </div>
                </CardContent>
                <div className="px-6 pb-4 flex justify-between items-center">
                  <Badge variant="outline" className={`${
                    ticket.prioridad === 'critica' ? 'border-red-300 text-red-600' :
                    ticket.prioridad === 'alta' ? 'border-orange-300 text-orange-600' :
                    'border-slate-300 text-slate-600'
                  }`}>
                    {ticket.prioridad}
                  </Badge>
                  <span className="text-xs text-slate-400">
                    {(ticket.created_at || ticket.fecha_creacion) 
                      ? new Date(ticket.created_at || ticket.fecha_creacion).toLocaleDateString('es-DO')
                      : ''}
                  </span>
                </div>
              </>
            )}
            onItemClick={(ticket) => openDetailDialog(ticket)}
          />
        ) : viewMode === 'list' ? (
          <ListView
            items={filteredTickets}
            renderItem={(ticket) => (
              <>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-xs text-slate-400">#{ticket.numero}</span>
                    <p className="font-medium text-sm text-slate-900 dark:text-white truncate">{ticket.titulo}</p>
                    <Badge variant="outline" className={`text-xs ${
                      ticket.prioridad === 'critica' ? 'border-red-300 text-red-600' :
                      ticket.prioridad === 'alta' ? 'border-orange-300 text-orange-600' :
                      'border-slate-300 text-slate-600'
                    }`}>
                      {ticket.prioridad}
                    </Badge>
                  </div>
                  <p className="text-xs text-slate-500 truncate mt-0.5">{ticket.solicitante_nombre} • {ticket.categoria_nombre}</p>
                </div>
                <div className="flex items-center gap-3 ml-4">
                  <Badge className={`text-xs ${
                    ticket.estado === 'resuelto' || ticket.estado === 'completado' ? 'bg-green-100 text-green-700' :
                    ticket.estado === 'en_progreso' ? 'bg-blue-100 text-blue-700' :
                    'bg-yellow-100 text-yellow-700'
                  }`}>
                    {ticket.estado}
                  </Badge>
                </div>
              </>
            )}
            onItemClick={(ticket) => openDetailDialog(ticket)}
          />
        ) : (
          /* Table View - Default */
          <div className="space-y-3">
            {filteredTickets.map((ticket) => {
              const isOwnTicket = ticket.user_id === user?.id || ticket.created_by === user?.id;
              const canEdit = canEditTicket(ticket);
              return (
              <Card key={ticket.id} className="border-slate-200 dark:border-slate-700 dark:bg-slate-800 hover:shadow-md transition-shadow">
                <CardContent className="py-4">
                  <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                    <div className="flex items-start gap-3 sm:gap-4 min-w-0">
                      <div className="text-center shrink-0">
                        <span className="text-xs text-slate-500 dark:text-slate-400">#{ticket.numero}</span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <h3 className="font-semibold text-slate-900 dark:text-white break-words">{ticket.titulo}</h3>
                        <div className="flex flex-wrap items-center gap-x-3 gap-y-1 mt-1 text-sm text-slate-500 dark:text-slate-400">
                          <span className="flex items-center gap-1">
                            <User className="w-3 h-3" />
                            {ticket.solicitante_nombre}
                          </span>
                          {!isOwnTicket && (
                            <Badge variant="outline" className="text-xs bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-900/30 dark:text-purple-300 dark:border-purple-700">
                              <Users className="w-3 h-3 mr-1" />
                              Supervisado
                            </Badge>
                          )}
                          {ticket.categoria_name && (
                            <Badge variant="outline" className="text-xs">{ticket.categoria_name}</Badge>
                          )}
                          {ticket.sub_categoria && (
                            <Badge variant="outline" className="text-xs bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-300 dark:border-indigo-700">
                              {ticket.sub_categoria}
                            </Badge>
                          )}
                          {ticket.asignado_a_nombre && (
                            <span className="flex items-center gap-1 text-green-600">
                              <User className="w-3 h-3" />
                              Asignado: {ticket.asignado_a_nombre}
                            </span>
                          )}
                          {ticket.archivo_adjunto_nombre && (
                            <span className="flex items-center gap-1 text-blue-600">
                              <FileText className="w-3 h-3" />
                              {ticket.archivo_adjunto_nombre}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-wrap items-center gap-2 sm:gap-3 sm:shrink-0">
                      {(() => {
                        const s = slaSemaforo(ticket);
                        return s ? (
                          <span
                            title={s.label}
                            data-testid={`sla-semaforo-${ticket.id}`}
                            className="inline-flex items-center gap-1"
                          >
                            <span className={`w-3 h-3 rounded-full ${s.clase} ${s.pulse ? "animate-pulse" : ""} ring-2 ring-white dark:ring-slate-700 shadow`} />
                            <span className="text-[10px] uppercase tracking-wide text-slate-400">SLA</span>
                          </span>
                        ) : null;
                      })()}
                      {ticket.es_urgente && (
                        <Badge className="bg-red-600 text-white border-0 uppercase text-xs" data-testid={`list-urgente-badge-${ticket.id}`}>
                          <AlertTriangle className="w-3 h-3 mr-1" /> URGENTE
                        </Badge>
                      )}
                      {getPrioridadBadge(ticket.prioridad, ticket.prioridad_color)}
                      {getEstadoBadge(ticket.estado)}
                      {modulo && ticket.estatus_final === "Cerrado Conforme" && (
                        <Badge className="bg-emerald-600 text-white border-0" data-testid={`badge-cerrado-conforme-${ticket.id}`}>
                          <CheckCircle2 className="w-3 h-3 mr-1" /> Cerrado Conforme
                        </Badge>
                      )}
                      {compromisoVencido(ticket) && (
                        <Badge className="bg-red-100 text-red-700 border border-red-300" data-testid={`badge-compromiso-vencido-${ticket.id}`}>
                          <Clock className="w-3 h-3 mr-1" /> Compromiso vencido
                        </Badge>
                      )}
                      <div className="flex gap-1 ml-auto sm:ml-0">
                        <Button 
                          variant="outline" 
                          size="sm" 
                          onClick={() => openDetailDialog(ticket)}
                          className="border-blue-200 text-blue-600 hover:bg-blue-50 dark:border-blue-700 dark:text-blue-400"
                          data-testid={`view-ticket-${ticket.id}`}
                        >
                          <Eye className="w-4 h-4 mr-1" />
                          Ver
                        </Button>
                        {canEdit && (
                          <Button 
                            variant="outline" 
                            size="sm" 
                            onClick={() => openEditDialog(ticket)}
                            className="border-green-200 text-green-600 hover:bg-green-50 dark:border-green-700 dark:text-green-400"
                            data-testid={`edit-ticket-${ticket.id}`}
                          >
                            <Pencil className="w-4 h-4 mr-1" />
                            Editar
                          </Button>
                        )}
                        {canDeleteTicket() && (
                          <Button 
                            variant="ghost" 
                            size="sm" 
                            onClick={() => deleteTicket(ticket.id)}
                            className="text-red-500 hover:text-red-700 hover:bg-red-50"
                            data-testid={`delete-ticket-${ticket.id}`}
                          >
                            <Trash2 className="w-4 h-4" />
                          </Button>
                        )}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
              );
            })}
          </div>
        )}
        </div>
        )}

        {/* Paso 1: ¿Qué deseas realizar? */}
        <Dialog open={showTypeDialog} onOpenChange={setShowTypeDialog}>
          <DialogContent className="max-w-md" data-testid="ticket-type-dialog">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Ticket className="w-5 h-5 text-[#0C314C]" />
                ¿Qué deseas realizar?
              </DialogTitle>
            </DialogHeader>
            <div className="grid gap-3 py-2">
              {!modulo && (
              <button
                onClick={() => iniciarNuevoTicket("Solicitud")}
                className="w-full text-left p-4 rounded-xl border border-slate-200 hover:border-[#0C314C] hover:bg-slate-50 transition-colors dark:border-slate-700 dark:hover:bg-slate-800"
                data-testid="ticket-type-solicitud"
              >
                <p className="font-semibold text-slate-900 dark:text-white">Solicitud</p>
                <p className="text-sm text-slate-500">Crear un ticket de soporte / solicitud normal</p>
              </button>
              )}
              <button
                onClick={() => iniciarNuevoTicket("Queja Cliente")}
                className="w-full text-left p-4 rounded-xl border border-slate-200 hover:border-red-400 hover:bg-red-50 transition-colors dark:border-slate-700 dark:hover:bg-red-900/20"
                data-testid="ticket-type-queja"
              >
                <p className="font-semibold text-slate-900 dark:text-white">Queja de Cliente</p>
                <p className="text-sm text-slate-500">Registrar una queja recibida de un cliente</p>
              </button>
              <button
                onClick={() => iniciarNuevoTicket("Oportunidad de Mejora")}
                className="w-full text-left p-4 rounded-xl border border-slate-200 hover:border-emerald-400 hover:bg-emerald-50 transition-colors dark:border-slate-700 dark:hover:bg-emerald-900/20"
                data-testid="ticket-type-oportunidad"
              >
                <p className="font-semibold text-slate-900 dark:text-white">Oportunidad de Mejora</p>
                <p className="text-sm text-slate-500">Documentar una oportunidad de mejora (interna o externa)</p>
              </button>
              {modulo && (
                <button
                  onClick={iniciarNuevoDetractor}
                  className="w-full text-left p-4 rounded-xl border border-slate-200 hover:border-red-500 hover:bg-red-50 transition-colors dark:border-slate-700 dark:hover:bg-red-900/20"
                  data-testid="ticket-type-detractores"
                >
                  <p className="font-semibold text-slate-900 dark:text-white">Detractores</p>
                  <p className="text-sm text-slate-500">Registrar manualmente un hallazgo de cliente detractor (NPS bajo)</p>
                </button>
              )}
            </div>
          </DialogContent>
        </Dialog>

        {/* New Ticket Dialog */}
        <Dialog open={showDialog} onOpenChange={setShowDialog}>
          <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Ticket className="w-5 h-5 text-[#0C314C]" />
                {formData.tipo_ticket === "Queja Cliente" ? "Nueva Queja de Cliente"
                  : formData.tipo_ticket === "Oportunidad de Mejora" ? "Nueva Oportunidad de Mejora"
                  : formData.tipo_ticket === "Detractores" ? "Nuevo Detractor"
                  : (modulo ? "Nuevo Hallazgo" : "Nuevo Ticket")}
              </DialogTitle>
            </DialogHeader>
            
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>{formData.tipo_ticket === "Solicitud" ? "Título *"
                  : (modulo && formData.tipo_ticket === "Oportunidad de Mejora") ? "Oportunidad de Mejora *"
                  : (modulo && formData.tipo_ticket === "Detractores") ? "Nombre del Detractor *"
                  : "Nombre del cliente *"}</Label>
                <Input
                  value={formData.titulo}
                  onChange={(e) => setFormData({...formData, titulo: e.target.value})}
                  placeholder={formData.tipo_ticket === "Solicitud" ? "Breve descripción del problema"
                    : (modulo && formData.tipo_ticket === "Oportunidad de Mejora") ? "Oportunidad de Mejora"
                    : (modulo && formData.tipo_ticket === "Detractores") ? "Nombre del Detractor"
                    : "Nombre del cliente"}
                  data-testid="ticket-titulo-input"
                />
              </div>
              
              <div className="space-y-2">
                <Label>{formData.tipo_ticket === "Queja Cliente" ? "Descripción de la queja *"
                  : formData.tipo_ticket === "Oportunidad de Mejora" ? "Descripción de la oportunidad *"
                  : "Descripción *"}</Label>
                <Textarea
                  value={formData.descripcion}
                  onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                  placeholder="Detalle el problema o solicitud"
                  rows={4}
                  data-testid="ticket-descripcion-input"
                />
              </div>

              {formData.tipo_ticket === "Oportunidad de Mejora" && (
                <div className="space-y-2">
                  <Label>Vía</Label>
                  <Select
                    value={formData.via || ""}
                    onValueChange={(value) => setFormData({...formData, via: value})}
                  >
                    <SelectTrigger data-testid="ticket-via-select">
                      <SelectValue placeholder="Seleccionar vía" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="Internas">Internas</SelectItem>
                      <SelectItem value="Externas">Externas</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              )}
              
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Departamento a asignar</Label>
                  <Select
                    value={formData.categoria_id || "none"}
                    onValueChange={(value) => handleCategoriaChange(value === "none" ? "" : value)}
                  >
                    <SelectTrigger data-testid="ticket-categoria-select">
                      <SelectValue placeholder="Seleccionar" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="none">Sin asignar</SelectItem>
                      {categorias.map((cat) => (
                        <SelectItem key={cat.id} value={cat.id}>
                          <div className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: cat.color }} />
                            {cat.name}
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div className="space-y-2">
                  <Label>Prioridad {!userIsAdmin() && <span className="text-[10px] text-slate-400">(automática)</span>}</Label>
                  <Select
                    value={formData.prioridad_id || formData.prioridad}
                    disabled={!userIsAdmin()}
                    onValueChange={(value) => {
                      const prio = prioridades.find(p => p.id === value);
                      if (prio) {
                        setFormData({...formData, prioridad_id: prio.id, prioridad: prio.name.toLowerCase()});
                      } else {
                        setFormData({...formData, prioridad: value, prioridad_id: ""});
                      }
                    }}
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Seleccionar" />
                    </SelectTrigger>
                    <SelectContent>
                      {prioridades.map((prio) => (
                        <SelectItem key={prio.id} value={prio.id}>
                          <div className="flex items-center gap-2">
                            <div className="w-3 h-3 rounded-full" style={{ backgroundColor: prio.color }} />
                            {prio.name}
                          </div>
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              {/* Sub-categoria: NO aplica para Queja de Cliente ni Oportunidad de Mejora */}
              {needsSubCategoria(formData.categoria_id) && formData.tipo_ticket === "Solicitud" && (
                <div className="space-y-2">
                  <Label>Sub-categoría <span className="text-red-500">*</span></Label>
                  <Select
                    value={formData.sub_categoria || ""}
                    onValueChange={(value) => { setFormData({ ...formData, sub_categoria: value }); aplicarPlantillas(plantillasCategoria, value); }}
                  >
                    <SelectTrigger
                      className={!formData.sub_categoria ? "border-red-300" : ""}
                      data-testid="ticket-sub-categoria-select"
                    >
                      <SelectValue placeholder="Seleccionar sub-categoría" />
                    </SelectTrigger>
                    <SelectContent>
                      {getSubCategoriaOptions(formData.categoria_id).map((sc) => (
                        <SelectItem key={sc} value={sc} data-testid={`ticket-sub-categoria-option-${sc.toLowerCase().replace(/\s+/g, "-")}`}>
                          {sc}
                        </SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              )}

              {/* Asignado a - usuarios del "Departamento a asignar" seleccionado */}
              <div className="space-y-2">
                <Label>Asignar a <span className="text-red-500">*</span></Label>
                <Select
                  value={formData.asignado_a || ""}
                  onValueChange={(value) => setFormData({...formData, asignado_a: value})}
                  disabled={!formData.categoria_id}
                >
                  <SelectTrigger
                    className={!formData.asignado_a && formData.categoria_id ? "border-red-300" : ""}
                    data-testid="ticket-asignado-a-select"
                  >
                    <SelectValue placeholder={formData.categoria_id ? "Seleccionar usuario (obligatorio)" : "Seleccione primero un Departamento a asignar"} />
                  </SelectTrigger>
                  <SelectContent>
                    {(((formData.tipo_ticket === "Queja Cliente" || formData.tipo_ticket === "Oportunidad de Mejora")
                        ? usuariosCategoria.filter(u => u.es_supervisor)
                        : usuariosCategoria)).map((u) => (
                      <SelectItem key={u.id} value={u.id}>
                        {u.name} {u.position ? `(${u.position})` : `(${u.email})`}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                {formData.categoria_id
                  && (formData.tipo_ticket === "Queja Cliente" || formData.tipo_ticket === "Oportunidad de Mejora")
                  && usuariosCategoria.filter(u => u.es_supervisor).length === 0
                  && usuariosCategoria.length > 0 && (
                  <p className="text-xs text-amber-600" data-testid="ticket-no-supervisores-msg">
                    Este "Departamento a asignar" no tiene supervisores. Las quejas y oportunidades solo pueden asignarse a supervisores.
                  </p>
                )}
                {formData.categoria_id && usuariosCategoria.length === 0 && ["administrador","admin","superadmin"].includes((user?.role || "").toLowerCase()) && (
                  <p className="text-xs text-amber-600">
                    No hay usuarios habilitados en este "Departamento a asignar". Configúralos en {modulo ? "Hallazgos Auditoria" : "Mesa de Ayuda"} → Departamento a asignar.
                  </p>
                )}
                {!formData.categoria_id && (
                  <p className="text-xs text-slate-500">
                    Seleccione un "Departamento a asignar" para ver los usuarios disponibles
                  </p>
                )}
                {formData.categoria_id && !formData.asignado_a && usuariosCategoria.length > 0 && (
                  <p className="text-xs text-red-500">
                    Debe seleccionar un usuario para asignar el ticket
                  </p>
                )}
              </div>

              {/* Custom Template Fields */}
              {templateFields.length > 0 && (
                <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                  <div className="flex items-center gap-2 mb-3">
                    <FormInput className="w-5 h-5 text-[#0C314C]" />
                    <h4 className="font-medium text-slate-900 dark:text-white">
                      Campos Personalizados de la Plantilla
                    </h4>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-testid="custom-fields-section">
                    {templateFields
                      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
                      .map(field => renderCustomField(field))}
                  </div>
                </div>
              )}
              
              <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                <h4 className="font-medium text-slate-900 dark:text-white mb-3">Datos del Solicitante</h4>
                <div className="space-y-4">
                  <div className="space-y-2">
                    <Label>Nombre Completo *</Label>
                    <Input
                      value={formData.solicitante_nombre}
                      onChange={(e) => setFormData({...formData, solicitante_nombre: e.target.value})}
                      placeholder="Nombre y apellido"
                    />
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4">
                    <div className="space-y-2">
                      <Label>Email</Label>
                      <Input
                        type="email"
                        value={formData.solicitante_email}
                        onChange={(e) => setFormData({...formData, solicitante_email: e.target.value})}
                        placeholder="correo@ejemplo.com"
                      />
                    </div>
                    <div className="space-y-2">
                      <Label>Teléfono</Label>
                      <Input
                        value={formData.solicitante_telefono}
                        onChange={(e) => setFormData({...formData, solicitante_telefono: e.target.value})}
                        placeholder="809-000-0000"
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* File Upload - Multiple files with Drag & Drop */}
              <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                <Label className="mb-2 block">Archivos Adjuntos (máx. 15MB cada uno)</Label>
                
                {/* Drop Zone */}
                <div 
                  className={`border-2 border-dashed rounded-lg p-6 text-center cursor-pointer transition-colors ${
                    isDragging 
                      ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' 
                      : 'border-slate-300 dark:border-slate-600 hover:border-[#0C314C]'
                  }`}
                  onClick={() => fileInputRef.current?.click()}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
                >
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                    className="hidden"
                    multiple
                  />
                  {uploadingFile ? (
                    <div className="flex items-center justify-center gap-2">
                      <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
                      <span className="text-slate-500">Subiendo archivos...</span>
                    </div>
                  ) : (
                    <>
                      <Upload className={`w-8 h-8 mx-auto mb-2 ${isDragging ? 'text-blue-500' : 'text-slate-400'}`} />
                      <p className="text-sm text-slate-500">
                        {isDragging ? 'Suelta los archivos aquí' : 'Arrastra archivos aquí o haz clic para seleccionar'}
                      </p>
                      <p className="text-xs text-slate-400 mt-1">
                        Puedes seleccionar múltiples archivos (hasta 15MB cada uno)
                      </p>
                    </>
                  )}
                </div>

                {/* Attached Files List */}
                {attachedFiles.length > 0 && (
                  <div className="mt-3 space-y-2">
                    <p className="text-xs text-slate-500 font-medium">{attachedFiles.length} archivo(s) adjunto(s):</p>
                    {attachedFiles.map((file, index) => (
                      <div key={index} className="flex items-center justify-between bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                        <div className="flex items-center gap-3">
                          <FileText className="w-6 h-6 text-blue-500" />
                          <div>
                            <p className="text-sm font-medium text-slate-900 dark:text-white truncate max-w-[200px]">
                              {file.filename}
                            </p>
                            <p className="text-xs text-slate-500">
                              {formatFileSize(file.size)}
                            </p>
                          </div>
                        </div>
                        <Button
                          variant="ghost"
                          size="sm"
                          onClick={(e) => { e.stopPropagation(); removeAttachedFile(index); }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <X className="w-4 h-4" />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            
            <DialogFooter>
              <Button variant="outline" onClick={() => setShowDialog(false)}>
                Cancelar
              </Button>
              <Button 
                onClick={handleSubmit}
                disabled={isSubmittingTicket}
                data-testid="create-ticket-submit-btn"
                className="bg-[#0C314C] hover:bg-[#2a4d7a] text-white disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isSubmittingTicket ? "Creando..." : "Crear Ticket"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Detail Dialog */}
        <Dialog open={showDetailDialog} onOpenChange={setShowDetailDialog}>
          <DialogContent className="max-w-2xl sm:max-w-3xl max-h-[85vh] flex flex-col">
            {selectedTicket && (
              <>
                <ClienteAtencionWatcher nombre={selectedTicket.solicitante_nombre} />
                <DialogHeader className="flex-shrink-0">
                  <DialogTitle className="flex items-center gap-2">
                    <span className="text-slate-500">#{selectedTicket.numero}</span>
                    {selectedTicket.titulo}
                  </DialogTitle>
                  <div className="flex items-center gap-2 mt-2 flex-wrap">
                    {selectedTicket.es_urgente && (
                      <Badge className="bg-red-600 text-white border-0 uppercase text-xs animate-pulse" data-testid="detail-urgente-badge">
                        <AlertTriangle className="w-3 h-3 mr-1" /> URGENTE
                      </Badge>
                    )}
                    {getPrioridadBadge(selectedTicket.prioridad, selectedTicket.prioridad_color)}
                    {getEstadoBadge(selectedTicket.estado)}
                    {modulo && selectedTicket.estatus_final === "Cerrado Conforme" && (
                      <Badge className="bg-emerald-600 text-white border-0" data-testid="detail-cerrado-conforme-badge">
                        <CheckCircle2 className="w-3 h-3 mr-1" /> Cerrado Conforme
                      </Badge>
                    )}
                    {compromisoVencido(selectedTicket) && (
                      <Badge className="bg-red-100 text-red-700 border border-red-300" data-testid="detail-compromiso-vencido-badge">
                        <Clock className="w-3 h-3 mr-1" /> Compromiso vencido
                      </Badge>
                    )}
                    {selectedTicket.categoria_name && (
                      <Badge variant="outline">{selectedTicket.categoria_name}</Badge>
                    )}
                    {selectedTicket.sub_categoria && (
                      <Badge variant="outline" className="bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-900/20 dark:text-indigo-300 dark:border-indigo-700">
                        {selectedTicket.sub_categoria}
                      </Badge>
                    )}
                    <Badge variant="outline" className="bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-700 dark:text-slate-200" data-testid="ticket-detail-tipo">
                      {selectedTicket.tipo_ticket || "Solicitud"}
                    </Badge>
                    {selectedTicket.via && (
                      <Badge variant="outline" className="bg-teal-50 text-teal-700 border-teal-200 dark:bg-teal-900/20 dark:text-teal-300">
                        Vía: {selectedTicket.via}
                      </Badge>
                    )}
                  </div>
                </DialogHeader>
                
                <div className="flex-1 overflow-y-auto space-y-4 py-4 pr-2">
                  <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-4">
                    <p className="text-slate-700 dark:text-slate-300 whitespace-pre-wrap">
                      {selectedTicket.descripcion}
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-4 text-sm">
                    <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                      <User className="w-4 h-4" />
                      <span>Solicitante: {selectedTicket.solicitante_nombre}</span>
                    </div>
                    {selectedTicket.solicitante_email && (
                      <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                        <Mail className="w-4 h-4" />
                        <span>{selectedTicket.solicitante_email}</span>
                      </div>
                    )}
                    {selectedTicket.solicitante_telefono && (
                      <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                        <Phone className="w-4 h-4" />
                        <span>{selectedTicket.solicitante_telefono}</span>
                      </div>
                    )}
                    {selectedTicket.asignado_a_nombre && (
                      <div className="flex items-center gap-2 text-green-600">
                        <User className="w-4 h-4" />
                        <span>Asignado: {selectedTicket.asignado_a_nombre}</span>
                        <Button
                          size="sm"
                          variant="outline"
                          className="ml-2 h-6 text-xs text-amber-600 border-amber-300 hover:bg-amber-50"
                          onClick={openReassignDialog}
                          data-testid="reasignar-btn"
                        >
                          <ArrowRightLeft className="w-3 h-3 mr-1" />
                          Reasignar
                        </Button>
                      </div>
                    )}
                    <div className="flex items-center gap-2 text-slate-600 dark:text-slate-400">
                      <Clock className="w-4 h-4" />
                      <span>Creado: {new Date(selectedTicket.fecha_creacion).toLocaleDateString('es-ES')}</span>
                    </div>
                  </div>

                  {/* Custom Fields Data Display */}
                  {selectedTicket.custom_fields_data && Object.keys(selectedTicket.custom_fields_data).length > 0 && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                      <div className="flex items-center gap-2 mb-3">
                        <FormInput className="w-4 h-4 text-[#0C314C]" />
                        <Label className="text-slate-900 dark:text-white font-medium">Campos Personalizados</Label>
                      </div>
                      <div className="grid grid-cols-2 gap-3 bg-slate-50 dark:bg-slate-800 rounded-lg p-4">
                        {(selectedTicket.custom_fields_schema || []).map((field) => {
                          const fieldKey = field.name || field.id;
                          const value = selectedTicket.custom_fields_data[fieldKey];
                          if (value === undefined || value === "" || value === null) return null;
                          
                          const displayValue = field.field_type === "checkbox" 
                            ? (value === true || value === "true" ? "Sí" : "No")
                            : field.field_type === "date" && value
                              ? new Date(value).toLocaleDateString('es-ES')
                              : value;
                          
                          return (
                            <div key={fieldKey} className="text-sm">
                              <span className="text-slate-500 dark:text-slate-400">{field.label}: </span>
                              <span className="text-slate-900 dark:text-white font-medium">{displayValue}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Archivos Adjuntos */}
                  {(selectedTicket.archivo_adjunto_url || (selectedTicket.archivos_adjuntos && selectedTicket.archivos_adjuntos.length > 0)) && (
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <Label className="flex items-center gap-2">
                          <FileText className="w-4 h-4" />
                          Archivos Adjuntos ({(selectedTicket.archivos_adjuntos?.length || 0) + (selectedTicket.archivo_adjunto_url ? 1 : 0)})
                        </Label>
                        {((selectedTicket.archivos_adjuntos?.length || 0) + (selectedTicket.archivo_adjunto_url ? 1 : 0)) > 1 && (
                          <Button
                            variant="outline"
                            size="sm"
                            onClick={() => downloadAllAttachments(selectedTicket.id, selectedTicket.numero)}
                            className="text-green-600 border-green-300 hover:bg-green-50"
                            data-testid="download-all-attachments-btn"
                          >
                            <Download className="w-4 h-4 mr-1" />
                            Descargar Todos (ZIP)
                          </Button>
                        )}
                      </div>
                      
                      <div className="space-y-2">
                        {/* Legacy single attachment */}
                        {selectedTicket.archivo_adjunto_url && (
                          <div className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
                            <div className="flex items-center gap-3">
                              <FileText className="w-5 h-5 text-blue-500" />
                              <span className="text-sm text-blue-700 dark:text-blue-300 truncate max-w-[200px]">
                                {selectedTicket.archivo_adjunto_nombre}
                              </span>
                            </div>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => window.open(`${API}${selectedTicket.archivo_adjunto_url}`, '_blank')}
                            >
                              <Download className="w-4 h-4" />
                            </Button>
                          </div>
                        )}
                        
                        {/* Multiple attachments */}
                        {selectedTicket.archivos_adjuntos?.map((adj, idx) => (
                          <div key={idx} className="flex items-center justify-between bg-blue-50 dark:bg-blue-900/20 rounded-lg p-3">
                            <div className="flex items-center gap-3">
                              <FileText className="w-5 h-5 text-blue-500" />
                              <span className="text-sm text-blue-700 dark:text-blue-300 truncate max-w-[200px]">
                                {adj.filename}
                              </span>
                            </div>
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => window.open(`${API}${adj.url}`, '_blank')}
                            >
                              <Download className="w-4 h-4" />
                            </Button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                                    {/* Correspondencia Interna Actions */}
                  {isCorrespondenciaTicket(selectedTicket) && selectedTicket.estado !== 'resuelto' && selectedTicket.estado !== 'cerrado' && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                      <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg p-4" data-testid="correspondencia-actions-admin">
                        <Label className="text-xs text-indigo-600 dark:text-indigo-400 mb-3 block font-semibold">Acciones de Correspondencia</Label>
                        <p className="text-sm text-slate-600 dark:text-slate-400 mb-3">
                          Revise el reporte adjunto y confirme o decline la correspondencia.
                        </p>
                        <div className="flex gap-3">
                          <Button
                            onClick={handleRecibirCorrespondencia}
                            disabled={correspondenciaLoading}
                            className="bg-green-600 hover:bg-green-700 text-white"
                            data-testid="recibir-correspondencia-btn"
                          >
                            {correspondenciaLoading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                            Recibir
                          </Button>
                          <Button
                            variant="outline"
                            onClick={() => setShowDeclinarDialog(true)}
                            disabled={correspondenciaLoading}
                            className="border-red-300 text-red-600 hover:bg-red-50 dark:border-red-700 dark:text-red-400"
                            data-testid="declinar-correspondencia-btn"
                          >
                            <X className="w-4 h-4 mr-2" />
                            Declinar
                          </Button>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Estado actions - Solo visible para roles autorizados */}
                  {canChangeStatus(selectedTicket) && (
                  <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                    <Label className="mb-2 block">Cambiar Estado</Label>
                    <div className="flex flex-wrap gap-2">
                      {["abierto", "en_progreso", "pendiente", "resuelto", ...(userIsAdmin() ? ["cerrado", "completado"] : [])].map((estado) => (
                        <Button
                          key={estado}
                          variant={selectedTicket.estado === estado ? "default" : "outline"}
                          size="sm"
                          onClick={() => updateEstado(selectedTicket.id, estado)}
                          className={selectedTicket.estado === estado ? (estado === "completado" ? "bg-green-600 text-white" : "bg-[#0C314C] text-white") : (estado === "completado" ? "border-green-500 text-green-600 hover:bg-green-50" : "")}
                        >
                          {estado === "completado" && <PackageCheck className="w-4 h-4 mr-1" />}
                          {estado.replace("_", " ")}
                        </Button>
                      ))}
                    </div>
                  </div>
                  )}
                  
                  {/* Mensaje si no tiene permisos para cambiar estado */}
                  {!canChangeStatus(selectedTicket) && (
                  <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                    <div className="flex items-center gap-2 text-sm text-slate-500 dark:text-slate-400 bg-slate-100 dark:bg-slate-800 rounded-lg p-3">
                      <AlertTriangle className="w-4 h-4" />
                      <span>Solo el administrador o el usuario asignado pueden cambiar el estado del ticket.</span>
                    </div>
                  </div>
                  )}
                  
                  {/* Historial de Reasignaciones */}
                  {selectedTicket.historial_reasignaciones?.length > 0 && (
                  <div className="border-t border-slate-200 dark:border-slate-700 pt-4" data-testid="historial-reasignaciones">
                    <Label className="mb-3 block flex items-center gap-2">
                      <History className="w-4 h-4 text-amber-600" />
                      Historial de Reasignaciones ({selectedTicket.historial_reasignaciones.length})
                    </Label>
                    <div className="space-y-3 max-h-48 overflow-y-auto">
                      {[...selectedTicket.historial_reasignaciones].reverse().map((h, idx) => (
                        <div key={h.id || idx} className="bg-amber-50 dark:bg-amber-900/20 rounded-lg p-3 border border-amber-200 dark:border-amber-800">
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-xs font-medium text-amber-800 dark:text-amber-300">
                              {h.reasignado_por_nombre}
                            </span>
                            <span className="text-xs text-slate-500">
                              {new Date(h.fecha).toLocaleString('es-ES')}
                            </span>
                          </div>
                          <div className="flex items-center gap-1 text-sm">
                            <span className="text-slate-600">{h.de_usuario_nombre}</span>
                            <ArrowRightLeft className="w-3 h-3 text-amber-500 mx-1" />
                            <span className="font-medium text-slate-800">{h.a_usuario_nombre}</span>
                          </div>
                          <p className="text-xs text-slate-500 mt-1 italic">Motivo: {h.motivo}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  )}

                  {/* ===== Hallazgos: Plan de Acción con fecha compromiso ===== */}
                  {modulo && selectedTicket.estatus_final === "Cerrado Conforme" && (selectedTicket.plan_accion || selectedTicket.fecha_compromiso) && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4" data-testid="plan-accion-readonly">
                      <Label className="mb-2 block flex items-center gap-2">
                        <FileText className="w-4 h-4 text-blue-600" />
                        Plan de Acción (cierre definitivo — solo lectura)
                      </Label>
                      <div className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3 text-sm text-slate-700 dark:text-slate-300 whitespace-pre-wrap">
                        {selectedTicket.plan_accion || "—"}
                      </div>
                      {selectedTicket.fecha_compromiso && (
                        <p className="text-xs text-slate-500 mt-1">Fecha compromiso: {String(selectedTicket.fecha_compromiso).slice(0, 10)}</p>
                      )}
                    </div>
                  )}
                  {modulo && selectedTicket.estatus_final !== "Cerrado Conforme" && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4" data-testid="plan-accion-section">
                      <Label className="mb-2 block flex items-center gap-2">
                        <FileText className="w-4 h-4 text-blue-600" />
                        Plan de Acción
                        {selectedTicket.plan_accion_por && (
                          <span className="text-xs text-slate-400 font-normal">
                            (última actualización: {selectedTicket.plan_accion_por})
                          </span>
                        )}
                      </Label>
                      <Textarea
                        value={planAccion}
                        onChange={(e) => setPlanAccion(e.target.value)}
                        placeholder="Describa el plan de acción para este hallazgo..."
                        rows={3}
                        data-testid="plan-accion-textarea"
                      />
                      <div className="flex flex-wrap items-center gap-2 mt-2">
                        <Label className="text-xs text-slate-500">Fecha compromiso:</Label>
                        <input
                          type="date"
                          value={fechaCompromiso}
                          onChange={(e) => setFechaCompromiso(e.target.value)}
                          className="h-8 px-2 text-xs border rounded-md bg-white dark:bg-slate-800 dark:border-slate-600 text-slate-700 dark:text-slate-200"
                          data-testid="fecha-compromiso-input"
                        />
                        <Button
                          size="sm"
                          onClick={guardarPlanAccion}
                          disabled={savingPlan || !planAccion.trim()}
                          className="h-8 bg-[#0C314C] hover:bg-[#2a4d7a] text-white text-xs"
                          data-testid="guardar-plan-accion-btn"
                        >
                          {savingPlan ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Guardar Plan"}
                        </Button>
                        {compromisoVencido(selectedTicket) && (
                          <span className="text-xs text-red-600 font-medium">⚠ La fecha compromiso está vencida</span>
                        )}
                      </div>
                    </div>
                  )}

                  {/* ===== Hallazgos: Estatus Final (solo usuarios de cierre definitivo) ===== */}
                  {modulo && cerradoresInfo.puede_cerrar
                    && ["resuelto", "completado"].includes(selectedTicket.estado)
                    && selectedTicket.estatus_final !== "Cerrado Conforme" && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4" data-testid="estatus-final-section">
                      <div className="bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 rounded-lg p-4">
                        <Label className="mb-2 block font-semibold text-emerald-800 dark:text-emerald-300">
                          Estatus Final (cierre definitivo)
                        </Label>
                        <div className="flex flex-col gap-2">
                          <Select value={estatusFinalSel} onValueChange={setEstatusFinalSel}>
                            <SelectTrigger data-testid="estatus-final-select">
                              <SelectValue placeholder="Seleccionar Estatus Final" />
                            </SelectTrigger>
                            <SelectContent>
                              <SelectItem value="cerrado_conforme">Cerrado Conforme</SelectItem>
                              <SelectItem value="no_cumple">No cumple</SelectItem>
                            </SelectContent>
                          </Select>
                          {estatusFinalSel === "no_cumple" && (
                            <Textarea
                              value={notaNoCumple}
                              onChange={(e) => setNotaNoCumple(e.target.value)}
                              placeholder="Razón del No Cumple (obligatoria). Quedará registrada en las notas del hallazgo."
                              rows={2}
                              className="border-red-300"
                              data-testid="nota-no-cumple-textarea"
                            />
                          )}
                          <Button
                            onClick={guardarEstatusFinal}
                            disabled={savingEstatusFinal || !estatusFinalSel || (estatusFinalSel === "no_cumple" && !notaNoCumple.trim())}
                            className={estatusFinalSel === "no_cumple" ? "bg-red-600 hover:bg-red-700 text-white w-fit" : "bg-emerald-600 hover:bg-emerald-700 text-white w-fit"}
                            data-testid="guardar-estatus-final-btn"
                          >
                            {savingEstatusFinal ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                            {estatusFinalSel === "no_cumple" ? "Guardar y Reabrir" : "Guardar Estatus Final"}
                          </Button>
                          <p className="text-xs text-slate-500">
                            "Cerrado Conforme" cierra definitivamente el hallazgo. "No cumple" lo reabre y registra la razón en las notas.
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* ===== Hallazgos: Trazabilidad ===== */}
                  {modulo && selectedTicket.historial_estados?.length > 0 && (
                    <div className="border-t border-slate-200 dark:border-slate-700 pt-4" data-testid="trazabilidad-section">
                      <Label className="mb-3 block flex items-center gap-2">
                        <History className="w-4 h-4 text-blue-600" />
                        Trazabilidad ({selectedTicket.historial_estados.length})
                      </Label>
                      <div className="space-y-2 max-h-48 overflow-y-auto">
                        {[...selectedTicket.historial_estados].reverse().map((h, idx) => (
                          <div key={h.id || idx} className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-2.5 border border-blue-100 dark:border-blue-800 text-xs">
                            <div className="flex items-center justify-between">
                              <span className="font-medium text-blue-800 dark:text-blue-300">
                                {h.estado_anterior ? `${String(h.estado_anterior).replace("_", " ")} → ` : ""}{String(h.estado).replace("_", " ")}
                              </span>
                              <span className="text-slate-500">{new Date(h.fecha).toLocaleString('es-ES')}</span>
                            </div>
                            <div className="text-slate-600 dark:text-slate-400 mt-0.5">
                              {h.usuario_nombre}{h.detalle ? ` — ${h.detalle}` : ""}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Comments */}
                  <div className="border-t border-slate-200 dark:border-slate-700 pt-4">
                    <Label className="mb-2 block flex items-center gap-2">
                      <MessageSquare className="w-4 h-4" />
                      Comentarios ({selectedTicket.comentarios?.length || 0})
                    </Label>
                    
                    {selectedTicket.comentarios?.length > 0 && (
                      <ScrollArea className="h-48 mb-4">
                        <div className="space-y-3">
                          {selectedTicket.comentarios.map((com, idx) => (
                            <div key={idx} className="bg-slate-50 dark:bg-slate-800 rounded-lg p-3">
                              <div className="flex items-center justify-between mb-1">
                                <span className="text-sm font-medium text-slate-900 dark:text-white">
                                  {com.autor}
                                </span>
                                <span className="text-xs text-slate-500">
                                  {new Date(com.fecha).toLocaleString('es-ES')}
                                </span>
                              </div>
                              <p className="text-sm text-slate-600 dark:text-slate-400">{com.texto}</p>
                            </div>
                          ))}
                        </div>
                      </ScrollArea>
                    )}
                    
                    <div className="flex gap-2">
                      <input
                        ref={supportFileRef}
                        type="file"
                        multiple
                        className="hidden"
                        onChange={(e) => attachSupportFiles(e.target.files)}
                        data-testid="ticket-adjuntar-input"
                      />
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() => supportFileRef.current?.click()}
                        disabled={attachingSupport}
                        title="Adjuntar archivo de soporte"
                        data-testid="ticket-adjuntar-btn"
                      >
                        {attachingSupport ? <Loader2 className="w-4 h-4 animate-spin" /> : <Paperclip className="w-4 h-4" />}
                      </Button>
                      <Input
                        value={nuevoComentario}
                        onChange={(e) => setNuevoComentario(e.target.value)}
                        placeholder="Agregar comentario..."
                        disabled={sendingComment}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' && !sendingComment) {
                            e.preventDefault();
                            addComentario();
                          }
                        }}
                        data-testid="ticket-comentario-input"
                      />
                      <Button
                        onClick={addComentario}
                        disabled={sendingComment || !nuevoComentario.trim()}
                        className="bg-[#0C314C] hover:bg-[#2a4d7a] text-white"
                        data-testid="ticket-comentario-enviar-btn"
                      >
                        {sendingComment ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                      </Button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </DialogContent>
        </Dialog>

        {/* Edit Ticket Dialog */}
        <Dialog open={showEditDialog} onOpenChange={setShowEditDialog}>
          <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <Pencil className="w-5 h-5 text-green-600" />
                Editar Ticket #{editingTicket?.numero}
              </DialogTitle>
            </DialogHeader>
            
            <div className="space-y-4 py-4">
              <div className="space-y-2">
                <Label>Título *</Label>
                <Input
                  value={formData.titulo}
                  onChange={(e) => setFormData({...formData, titulo: e.target.value})}
                  placeholder="Breve descripción del problema"
                />
              </div>
              
              <div className="space-y-2">
                <Label>Descripción *</Label>
                <Textarea
                  value={formData.descripcion}
                  onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                  placeholder="Describa el problema en detalle"
                  rows={4}
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Prioridad {!userIsAdmin() && <span className="text-[10px] text-slate-400">(automática)</span>}</Label>
                  <Select value={formData.prioridad_id} disabled={!userIsAdmin()} onValueChange={(value) => setFormData({...formData, prioridad_id: value})}>
                    <SelectTrigger data-testid="edit-ticket-prioridad-select">
                      <SelectValue placeholder="Seleccionar" />
                    </SelectTrigger>
                    <SelectContent>
                      {prioridades.map(p => (
                        <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
                
                <div className="space-y-2">
                  <Label>Departamento a asignar</Label>
                  <Select value={formData.categoria_id} onValueChange={(value) => setFormData({...formData, categoria_id: value})}>
                    <SelectTrigger>
                      <SelectValue placeholder="Seleccionar" />
                    </SelectTrigger>
                    <SelectContent>
                      {categorias.map(c => (
                        <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>
                      ))}
                    </SelectContent>
                  </Select>
                </div>
              </div>

              {/* Escalación URGENTE: solo supervisores y admins */}
              {canEscalateUrgente() && (
                <label
                  className={`flex items-start gap-3 rounded-lg border p-3 cursor-pointer transition-colors ${formData.es_urgente ? "border-red-300 bg-red-50 dark:bg-red-950/30" : "border-slate-200 dark:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800"}`}
                  data-testid="edit-ticket-urgente-label"
                >
                  <input
                    type="checkbox"
                    checked={!!formData.es_urgente}
                    onChange={(e) => setFormData({ ...formData, es_urgente: e.target.checked })}
                    className="mt-0.5 w-4 h-4 accent-red-600"
                    data-testid="edit-ticket-urgente-checkbox"
                  />
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <AlertTriangle className={`w-4 h-4 ${formData.es_urgente ? "text-red-600" : "text-slate-400"}`} />
                      <span className="text-sm font-semibold text-slate-800 dark:text-slate-100">Marcar como URGENTE</span>
                    </div>
                    <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
                      Cambia la prioridad a "Urgente" (SLA 1h) y notifica al ejecutivo asignado y a su supervisor con una alerta central.
                    </p>
                  </div>
                </label>
              )}

              {/* Archivos adjuntos */}
              <div className="space-y-2">
                <Label>Archivos Adjuntos</Label>
                <div className="flex items-center gap-2">
                  <input
                    type="file"
                    multiple
                    onChange={handleFileUpload}
                    className="hidden"
                    ref={fileInputRef}
                  />
                  <Button
                    type="button"
                    variant="outline"
                    onClick={() => fileInputRef.current?.click()}
                    disabled={uploadingFile}
                    className="w-full"
                  >
                    {uploadingFile ? (
                      <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                    ) : (
                      <Upload className="w-4 h-4 mr-2" />
                    )}
                    Agregar archivos
                  </Button>
                </div>
                
                {attachedFiles.length > 0 && (
                  <div className="mt-2 space-y-1">
                    {attachedFiles.map((file, index) => (
                      <div key={index} className="flex items-center justify-between p-2 bg-slate-50 dark:bg-slate-700 rounded text-sm">
                        <span className="flex items-center gap-2 truncate">
                          <FileText className="w-4 h-4 text-blue-500" />
                          {file.filename}
                        </span>
                        <Button
                          type="button"
                          variant="ghost"
                          size="sm"
                          onClick={() => setAttachedFiles(prev => prev.filter((_, i) => i !== index))}
                          className="text-red-500 h-6 w-6 p-0"
                        >
                          <X className="w-4 h-4" />
                        </Button>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => { setShowEditDialog(false); setEditingTicket(null); resetForm(); }}>
                Cancelar
              </Button>
              <Button 
                onClick={updateTicket}
                className="bg-green-600 hover:bg-green-700"
              >
                <CheckCircle2 className="w-4 h-4 mr-2" />
                Guardar Cambios
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Reassign Ticket Dialog */}
        <Dialog open={showReassignDialog} onOpenChange={setShowReassignDialog}>
          <DialogContent className="max-w-md" data-testid="reasignar-dialog">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2">
                <ArrowRightLeft className="w-5 h-5 text-amber-600" />
                Reasignar Ticket #{selectedTicket?.numero}
              </DialogTitle>
              <DialogDescription>
                Actualmente asignado a: <strong>{selectedTicket?.asignado_a_nombre}</strong>
              </DialogDescription>
            </DialogHeader>

            <div className="space-y-4 py-2">
              <div className="space-y-2">
                <Label>Filtrar por Departamento</Label>
                <SearchableSelect
                  value={reassignDeptFilter}
                  onValueChange={(v) => { setReassignDeptFilter(v); setReassignUsuarioId(""); }}
                  options={departamentos.map(d => ({ value: d.id, label: d.name || d.nombre }))}
                  allLabel="Todos los departamentos"
                  searchPlaceholder="Buscar departamento..."
                  emptyText="Departamento no encontrado."
                  data-testid="reasignar-dept-select"
                />
              </div>

              <div className="space-y-2">
                <Label>Nuevo Responsable <span className="text-red-500">*</span></Label>
                <SearchableSelect
                  value={reassignUsuarioId}
                  onValueChange={setReassignUsuarioId}
                  options={filteredReassignUsuarios
                    .filter(u => u.id !== selectedTicket?.asignado_a)
                    .map(u => ({ value: u.id, label: u.name || u.email }))}
                  allLabel="Seleccionar usuario"
                  searchPlaceholder="Buscar usuario..."
                  emptyText="Usuario no encontrado."
                  data-testid="reasignar-usuario-select"
                />
              </div>

              <div className="space-y-2">
                <Label>Motivo de la Reasignación <span className="text-red-500">*</span></Label>
                <Textarea
                  value={reassignMotivo}
                  onChange={(e) => setReassignMotivo(e.target.value)}
                  placeholder="Explique el motivo de la reasignación..."
                  rows={3}
                  data-testid="reasignar-motivo-input"
                />
              </div>
            </div>

            <DialogFooter>
              <Button variant="outline" onClick={() => setShowReassignDialog(false)}>
                Cancelar
              </Button>
              <Button
                onClick={handleReassign}
                disabled={reassignLoading || !reassignUsuarioId || !reassignMotivo.trim()}
                className="bg-amber-600 hover:bg-amber-700 text-white"
                data-testid="reasignar-confirmar-btn"
              >
                {reassignLoading ? <Loader2 className="w-4 h-4 animate-spin mr-1" /> : <ArrowRightLeft className="w-4 h-4 mr-1" />}
                Confirmar Reasignación
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {/* Declinar Correspondencia Dialog */}
        <Dialog open={showDeclinarDialog} onOpenChange={setShowDeclinarDialog}>
          <DialogContent className="max-w-md">
            <DialogHeader>
              <DialogTitle className="flex items-center gap-2 text-red-600">
                <X className="w-5 h-5" />
                Declinar Correspondencia
              </DialogTitle>
              <DialogDescription>
                Indique el motivo por el cual declina esta correspondencia.
              </DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <div>
                <Label>Motivo <span className="text-red-500">*</span></Label>
                <Textarea
                  value={declinarMotivo}
                  onChange={(e) => setDeclinarMotivo(e.target.value)}
                  placeholder="Explique por qué declina esta correspondencia..."
                  rows={3}
                  data-testid="declinar-motivo-input"
                />
              </div>
            </div>
            <DialogFooter>
              <Button variant="outline" onClick={() => { setShowDeclinarDialog(false); setDeclinarMotivo(""); }}>Cancelar</Button>
              <Button
                onClick={handleDeclinarCorrespondencia}
                disabled={correspondenciaLoading || !declinarMotivo.trim()}
                className="bg-red-600 hover:bg-red-700 text-white"
                data-testid="confirmar-declinar-btn"
              >
                {correspondenciaLoading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <X className="w-4 h-4 mr-2" />}
                Confirmar Declinación
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>

        {showScrollTop && (
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="fixed bottom-24 right-5 z-40 w-11 h-11 rounded-full bg-[#0C314C] hover:bg-[#2a4d7a] text-white shadow-lg flex items-center justify-center transition-opacity"
            aria-label="Volver arriba"
            data-testid="tickets-scroll-top-btn"
          >
            <ArrowUp className="w-5 h-5" />
          </button>
        )}
      </main>
    </div>
  );
}